/* Shrimpkutter Custom — app.js
   Mobile-Menu · Cart-Drawer · Cart-Fetch (AJAX) · Free-Shipping-Bar · PDP-Helpers
*/
(function() {
    'use strict';

    const $ = (sel, ctx = document) => ctx.querySelector(sel);
    const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

    /* ---------- Money Formatting ---------- */
    function formatMoney(cents) {
        const fmt = (window.Shrimp && window.Shrimp.money_format) || '{{amount}} €';
        const placeholderMatch = fmt.match(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/);
        const token = placeholderMatch ? placeholderMatch[1] : 'amount';
        let formatted;
        switch (token) {
            case 'amount_no_decimals':
                formatted = Math.round(cents / 100).toLocaleString('de-DE');
                break;
            case 'amount_with_comma_separator':
                formatted = (cents / 100).toFixed(2).replace('.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                formatted = Math.round(cents / 100).toLocaleString('de-DE');
                break;
            default:
                formatted = (cents / 100).toFixed(2).replace('.', ',');
        }
        if (placeholderMatch) return fmt.replace(placeholderMatch[0], formatted);
        return formatted + ' €';
    }

    /* ---------- iOS-safe Scroll-Lock ---------- */
    let scrollLockY = 0;
    let scrollLockCount = 0;
    function lockScroll() {
        scrollLockCount++;
        if (scrollLockCount > 1) return;
        scrollLockY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + scrollLockY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
    }
    function unlockScroll() {
        if (scrollLockCount > 0) scrollLockCount--;
        if (scrollLockCount > 0) return;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollLockY);
    }

    /* ---------- HTML Escape Helpers ---------- */
    function escAttr(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
            .replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;');
    }
    function escHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    /* ---------- Cart API ---------- */
    async function fetchCart() {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        return res.json();
    }
    async function changeCartItem(key, quantity) {
        const res = await fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity })
        });
        return res.json();
    }
    async function addToCart(formData) {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' },
            body: formData
        });
        const data = await res.json();
        return { ok: res.ok, status: res.status, data };
    }

    /* ---------- Cart-Error Toast ---------- */
    let cartErrorTimer = null;
    function showCartError(message) {
        let toast = $('[data-cart-error-toast]');
        if (!toast) {
            toast = document.createElement('div');
            toast.className = 'cart-error-toast';
            toast.setAttribute('data-cart-error-toast', '');
            toast.setAttribute('role', 'alert');
            document.body.appendChild(toast);
        }
        toast.textContent = '⚠️ ' + message;
        toast.classList.add('is-visible');
        clearTimeout(cartErrorTimer);
        cartErrorTimer = setTimeout(() => toast.classList.remove('is-visible'), 6000);
    }

    function parseAddError(data) {
        if (!data) return 'Produkt konnte nicht hinzugefügt werden.';
        if (data.description) return data.description;
        if (data.message) return data.message;
        return 'Produkt konnte nicht hinzugefügt werden.';
    }

    /* ---------- Inventory Pre-Check ---------- */
    const productCache = new Map();
    async function fetchProduct(handle) {
        if (productCache.has(handle)) return productCache.get(handle);
        try {
            const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
            if (!res.ok) return null;
            const data = await res.json();
            productCache.set(handle, data);
            return data;
        } catch { return null; }
    }
    function getFormHandle(form) {
        if (form.dataset && form.dataset.productHandle) return form.dataset.productHandle;
        const m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
        return m ? m[1] : null;
    }
    async function checkInventory(form, requestedQty) {
        const handle = getFormHandle(form);
        if (!handle) return { ok: true };
        const idInput = form.querySelector('[name="id"]');
        if (!idInput) return { ok: true };
        const variantId = String(idInput.value);
        const product = await fetchProduct(handle);
        if (!product) return { ok: true };
        const variant = (product.variants || []).find(v => String(v.id) === variantId);
        if (!variant) return { ok: true };
        if (variant.inventory_management !== 'shopify') return { ok: true };
        if (variant.inventory_policy === 'continue') return { ok: true };
        const available = variant.inventory_quantity;
        if (typeof available !== 'number') return { ok: true };
        const cart = await fetchCart();
        const existing = (cart.items || [])
            .filter(i => String(i.variant_id) === variantId)
            .reduce((sum, i) => sum + i.quantity, 0);
        const total = existing + requestedQty;
        if (total > available) {
            const remaining = Math.max(0, available - existing);
            const msg = existing > 0
                ? `Nur noch ${available} Stück verfügbar – Du hast bereits ${existing} im Warenkorb (max. ${remaining} weitere möglich).`
                : `Nur noch ${available} Stück verfügbar.`;
            return { ok: false, message: msg };
        }
        return { ok: true };
    }

    /* ---------- Cart-Drawer ---------- */
    function getDrawer() { return $('[data-cart-drawer]'); }
    function openCart() {
        const d = getDrawer();
        if (d) {
            d.classList.add('is-open');
            d.setAttribute('aria-hidden', 'false');
            d.setAttribute('aria-modal', 'true');
        }
        $$('[data-cart-toggle]').forEach(b => b.setAttribute('aria-expanded', 'true'));
        lockScroll();
        lastFocusBeforeCart = document.activeElement;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const drawer = getDrawer();
                const closeBtn = drawer && drawer.querySelector('.cart-drawer__close, [data-cart-close]');
                if (closeBtn) closeBtn.focus();
            });
        });
    }
    function closeCart() {
        const d = getDrawer();
        if (d) {
            d.classList.remove('is-open');
            d.setAttribute('aria-hidden', 'true');
            d.removeAttribute('aria-modal');
        }
        $$('[data-cart-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
        unlockScroll();
        if (lastFocusBeforeCart && typeof lastFocusBeforeCart.focus === 'function') {
            lastFocusBeforeCart.focus();
        }
    }
    let lastFocusBeforeCart = null;
    $$('[data-cart-toggle]').forEach(b => b.addEventListener('click', async e => {
        e.preventDefault();
        openCart();
        await refreshDrawerSection();
        refreshCart();
    }));
    document.addEventListener('click', e => {
        if (e.target.closest('[data-cart-close]')) {
            e.preventDefault();
            closeCart();
        }
    });

    /* ---------- Cart Render ---------- */
    function isTierItem(item) {
        const tierHandles = (window.Shrimp.tier_handles || []).map(h => String(h).toLowerCase()).filter(Boolean);
        const h = (item.handle || '').toLowerCase();
        return tierHandles.some(th => th && h.includes(th));
    }

    function isItemLocked(item) {
        const lockedHandles = (window.Shrimp.locked_handles || []).map(h => String(h).toLowerCase()).filter(Boolean);
        const h = (item.handle || '').toLowerCase();
        return lockedHandles.some(lh => lh && h.includes(lh)) || (item.properties && item.properties._locked);
    }

    function detectTiersInCart(cart) {
        window.Shrimp.cartHasTiers = (cart.items || []).some(item => isTierItem(item) && !isItemLocked(item));
    }

    async function autoCleanLockedItems(cart) {
        if (!cart || cart.item_count === 0) return false;
        const lockedItems = cart.items.filter(isItemLocked);
        if (lockedItems.length === 0) return false;
        const realTierItems = cart.items.filter(i => isTierItem(i) && !isItemLocked(i));
        if (realTierItems.length > 0) return false;
        for (const item of lockedItems) {
            try { await changeCartItem(item.key, 0); } catch { /* ignore */ }
        }
        return true;
    }

    async function refreshCart() {
        let cart = await fetchCart();
        if (await autoCleanLockedItems(cart)) {
            cart = await fetchCart();
        }
        detectTiersInCart(cart);
        updateCartCount(cart.item_count);
        updateShippingBar(cart.total_price);
        renderDrawerItems(cart);
        updateSubtotals(cart.total_price);
        updateTotalDiscount(cart.total_discount);
        loadCrossSells(cart);
    }

    /* ---------- Cross-Sell (Shopify Recommendations API) ---------- */
    async function loadCrossSells(cart) {
        const containers = $$('[data-cross-sell]');
        if (!containers.length) return;
        if (!cart || cart.item_count === 0) {
            containers.forEach(c => { c.setAttribute('hidden', ''); });
            return;
        }
        try {
            const seen = new Set(cart.items.map(i => i.product_id));
            const randomItem = cart.items[Math.floor(Math.random() * cart.items.length)];
            const sourceId = randomItem.product_id;
            const res = await fetch('/recommendations/products.json?product_id=' + sourceId + '&limit=8&intent=related', { credentials: 'same-origin' });
            const data = await res.json();
            const products = (data.products || []).filter(p => !seen.has(p.id) && p.available !== false).slice(0, 4);
            containers.forEach(c => {
                const grid = c.querySelector('[data-cross-sell-grid]');
                if (!grid) return;
                if (products.length === 0) {
                    c.setAttribute('hidden', '');
                    return;
                }
                grid.innerHTML = products.map(p => {
                    const variantId = (p.variants && p.variants[0] && p.variants[0].id) || '';
                    const img = (p.featured_image || (p.images && p.images[0]) || '');
                    const price = p.price != null ? formatMoney(p.price) : '';
                    return `
                        <article class="cross-sell-card">
                            <a href="${escAttr(p.url)}" class="cross-sell-card__media">
                                ${img ? `<img src="${escAttr(img)}" alt="${escAttr(p.title)}" loading="lazy">` : ''}
                            </a>
                            <div class="cross-sell-card__body">
                                <a href="${escAttr(p.url)}" class="cross-sell-card__title">${escHtml(p.title)}</a>
                                <span class="cross-sell-card__price">${price}</span>
                            </div>
                            ${variantId ? `
                                <form data-quick-add data-product-handle="${escAttr(p.handle)}">
                                    <input type="hidden" name="id" value="${escAttr(variantId)}">
                                    <input type="hidden" name="quantity" value="1">
                                    <button type="submit" class="cross-sell-card__add">In den Warenkorb</button>
                                </form>
                            ` : ''}
                        </article>
                    `;
                }).join('');
                c.removeAttribute('hidden');
            });
        } catch (err) {
            console.warn('Cross-sell load failed', err);
        }
    }
    function updateCartCount(count) {
        $$('[data-cart-count]').forEach(el => {
            el.textContent = count;
            if (count > 0) el.removeAttribute('hidden');
            else el.setAttribute('hidden', '');
        });
    }
    function updateSubtotals(price) {
        $$('[data-cart-subtotal]').forEach(el => { el.textContent = formatMoney(price); });
    }
    function updateTotalDiscount(totalDiscount) {
        $$('[data-cart-discount]').forEach(wrap => {
            const amountEl = wrap.querySelector('[data-cart-discount-amount]');
            if (totalDiscount > 0) {
                wrap.removeAttribute('hidden');
                if (amountEl) amountEl.textContent = '-' + formatMoney(totalDiscount);
            } else {
                wrap.setAttribute('hidden', '');
            }
        });
    }
    // Grundpreis (PAngV) aus /cart.js-Line-Item. Format wie Liquid-Snippet unit-price.
    function unitPriceHtml(item) {
        const m = item.unit_price_measurement;
        if (!m || !item.unit_price || item.unit_price <= 0) return '';
        const refVal = m.reference_value;
        const refUnit = escHtml(m.reference_unit || '');
        const per = (refVal && refVal !== 1) ? `${refVal}&nbsp;${refUnit}` : refUnit;
        return `<span class="unit-price unit-price--cart">${formatMoney(item.unit_price)}<span class="unit-price__per">&nbsp;/&nbsp;${per}</span></span>`;
    }
    function renderDrawerItems(cart) {
        const list = $('[data-cart-items]');
        const empty = $('[data-cart-empty]');
        const footer = $('[data-cart-footer]');
        const progress = $('[data-progress-wrap]');

        if (cart.item_count === 0) {
            if (list) { list.setAttribute('hidden', ''); list.innerHTML = ''; }
            if (empty) empty.removeAttribute('hidden');
            if (footer) footer.setAttribute('hidden', '');
            if (progress) progress.setAttribute('hidden', '');
            return;
        }

        if (empty) empty.setAttribute('hidden', '');
        if (footer) footer.removeAttribute('hidden');
        if (progress) progress.removeAttribute('hidden');
        if (!list) return;
        list.removeAttribute('hidden');

        const lockedHandles = (window.Shrimp.locked_handles || []).map(h => String(h).toLowerCase());
        const html = cart.items.map(item => {
            const discounts = (item.line_level_discount_allocations || []).map(d => `
                <li><span class="cart-item__discount-title">🏷️ ${escHtml((d.discount_application && d.discount_application.title) || 'Rabatt')}</span><span class="cart-item__discount-amount">-${formatMoney(d.amount)}</span></li>
            `).join('');
            const handleLc = (item.handle || '').toLowerCase();
            const isLocked = lockedHandles.some(h => h && handleLc.includes(h)) || (item.properties && item.properties._locked);
            const qtyControls = isLocked
                ? `<p class="cart-item__lock-badge"><span>🔒</span> Pflichtartikel Tierversand · Menge: ${parseInt(item.quantity, 10) || 0}</p>`
                : `<div class="cart-item__qty">
                        <button type="button" data-qty-decrease aria-label="Weniger">−</button>
                        <input type="number" min="0" value="${parseInt(item.quantity, 10) || 0}" data-qty-input data-key="${escAttr(item.key)}" aria-label="Menge">
                        <button type="button" data-qty-increase aria-label="Mehr">+</button>
                    </div>`;
            const removeBtn = isLocked ? '' : `<button type="button" class="cart-item__remove" data-cart-remove data-key="${escAttr(item.key)}" aria-label="Entfernen">×</button>`;
            const unitPrice = unitPriceHtml(item);
            // item.image kommt von der Cart-AJAX-API in Originalgroesse (bis
            // 3024px, mehrere MB) — fuer die 64-88px-Kachel Miniatur vom CDN
            // anfordern, sonst bleibt die Kachel mobil sekundenlang leer.
            const itemThumb = item.image ? item.image + (item.image.includes('?') ? '&' : '?') + 'width=180' : '';
            return `
            <li class="cart-item${isLocked ? ' cart-item--locked' : ''}" data-cart-item data-key="${escAttr(item.key)}"${isLocked ? ' data-locked="true"' : ''}>
                <a href="${escAttr(item.url)}" class="cart-item__media">
                    ${itemThumb ? `<img src="${escAttr(itemThumb)}" alt="${escAttr(item.title)}" width="88" height="88">` : ''}
                </a>
                <div class="cart-item__body">
                    <a href="${escAttr(item.url)}" class="cart-item__title">${escHtml(item.product_title)}</a>
                    ${item.variant_title ? `<p class="cart-item__variant">${escHtml(item.variant_title)}</p>` : ''}
                    <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
                    ${unitPrice}
                    ${discounts ? `<ul class="cart-item__discounts">${discounts}</ul>` : ''}
                    ${qtyControls}
                </div>
                ${removeBtn}
            </li>
        `;}).join('');
        list.innerHTML = html;
    }

    /* ---------- Progress Bar: konfigurierbare Milestones + Tier-Visibility ---------- */
    function isMilestoneVisible(visibility, hasTiers) {
        if (visibility === 'with_tiers') return hasTiers;
        if (visibility === 'without_tiers') return !hasTiers;
        return true;
    }

    function updateShippingBar(totalPrice) {
        const hasTiers = window.Shrimp.cartHasTiers === true;

        $$('[data-shipping-bar]').forEach(bar => {
            let milestones = [];
            try { milestones = JSON.parse(bar.dataset.milestones || '[]'); } catch { milestones = []; }
            if (milestones.length === 0) return;

            const visible = milestones.filter(m => isMilestoneVisible(m.visibility || 'always', hasTiers));

            if (visible.length === 0) {
                bar.setAttribute('hidden', '');
                return;
            }
            bar.removeAttribute('hidden');

            visible.sort((a, b) => a.threshold - b.threshold);
            const maxThreshold = visible[visible.length - 1].threshold;
            const pct = Math.min(100, (totalPrice / maxThreshold) * 100);

            const nextUnreached = visible.find(m => totalPrice < m.threshold);
            const allReached = !nextUnreached;
            const anyReached = visible.some(m => totalPrice >= m.threshold);

            let msg = '';
            if (nextUnreached) {
                const remaining = Math.max(0, nextUnreached.threshold - totalPrice);
                msg = (nextUnreached.text_remaining || '').replace('{amount}', formatMoney(remaining)).replace('__AMOUNT__', formatMoney(remaining));
            } else {
                const last = visible[visible.length - 1];
                msg = last.text_reached || '';
            }

            const fill = bar.querySelector('[data-shipping-fill]');
            const msgEl = bar.querySelector('[data-shipping-msg]');
            if (fill) fill.style.width = pct + '%';
            if (msgEl) msgEl.textContent = msg;
            bar.classList.toggle('is-reached', anyReached);
            bar.classList.toggle('is-all-done', allReached);

            bar.querySelectorAll('[data-milestone-threshold]').forEach(mile => {
                const t = parseInt(mile.dataset.milestoneThreshold, 10) || 0;
                const v = mile.dataset.milestoneVisibility || 'always';
                const show = isMilestoneVisible(v, hasTiers);
                if (!show) {
                    mile.style.display = 'none';
                    return;
                }
                mile.style.display = '';
                const newPos = maxThreshold > 0 ? (t / maxThreshold) * 100 : 0;
                mile.style.left = newPos + '%';
                mile.classList.toggle('is-reached', totalPrice >= t);
            });
        });

        let lowestThreshold = 0;
        const firstBar = $('[data-shipping-bar]');
        if (firstBar) {
            try {
                const arr = JSON.parse(firstBar.dataset.milestones || '[]')
                    .filter(m => isMilestoneVisible(m.visibility || 'always', hasTiers));
                arr.sort((a, b) => a.threshold - b.threshold);
                if (arr[0]) lowestThreshold = arr[0].threshold;
            } catch { /* ignore */ }
        }
        const shippingFree = lowestThreshold > 0 && totalPrice >= lowestThreshold;
        $$('[data-shipping-info]').forEach(el => {
            if (shippingFree) el.setAttribute('hidden', '');
            else el.removeAttribute('hidden');
        });
    }

    /* ---------- Cart Item Events (delegated + debounced) ---------- */
    const cartUpdateTimers = new Map();
    function scheduleCartUpdate(key, quantity) {
        clearTimeout(cartUpdateTimers.get(key));
        const t = setTimeout(async () => {
            cartUpdateTimers.delete(key);
            let cart = null;
            try {
                cart = await changeCartItem(key, quantity);
                if (!cart || typeof cart.total_price !== 'number' || !Array.isArray(cart.items)) {
                    throw new Error('Invalid cart response');
                }
            } catch (err) {
                console.warn('Cart change failed, falling back to fetchCart:', err);
                cart = await fetchCart();
            }

            if (!cart || typeof cart.total_price !== 'number') return;

            if (await autoCleanLockedItems(cart)) {
                refreshCart();
                return;
            }
            detectTiersInCart(cart);
            updateCartCount(cart.item_count);
            updateShippingBar(cart.total_price);
            updateSubtotals(cart.total_price);
            updateTotalDiscount(cart.total_discount);

            const itemRemoved = !cart.items.some(i => i.key === key);
            if (itemRemoved) {
                document.querySelectorAll('[data-cart-item][data-key="' + key + '"]').forEach(el => el.remove());
                if (cart.item_count === 0 && document.body.classList.contains('template-cart')) {
                    window.location.reload();
                    return;
                }
                renderDrawerItems(cart);
            } else {
                const line = cart.items.find(i => i.key === key);
                if (line) {
                    document.querySelectorAll('[data-cart-item][data-key="' + key + '"]').forEach(row => {
                        const priceEl = row.querySelector('.cart-item__price');
                        if (priceEl) priceEl.textContent = formatMoney(line.final_line_price);
                    });
                    document.querySelectorAll('[data-qty-input][data-key="' + key + '"]').forEach(input => {
                        const serverQty = line.quantity;
                        const userQty = parseInt(input.value, 10);
                        if (userQty !== serverQty) {
                            input.value = serverQty;
                            if (userQty > serverQty) {
                                showStockNotice(input, serverQty);
                            }
                        }
                    });
                }
            }
        }, 400);
        cartUpdateTimers.set(key, t);
    }

    function showStockNotice(input, maxQty) {
        const row = input.closest('.cart-item');
        if (!row) return;
        let notice = row.querySelector('.cart-item__stock-notice');
        if (!notice) {
            notice = document.createElement('p');
            notice.className = 'cart-item__stock-notice';
            row.querySelector('.cart-item__body, .cart-item__qty')?.appendChild(notice);
        }
        notice.textContent = 'Max. ' + maxQty + ' verfügbar';
        clearTimeout(notice._t);
        notice._t = setTimeout(() => notice.remove(), 4000);
    }

    document.addEventListener('click', async (e) => {
        const dec = e.target.closest('[data-qty-decrease]');
        const inc = e.target.closest('[data-qty-increase]');
        const rem = e.target.closest('[data-cart-remove]');
        if (dec || inc) {
            const wrap = e.target.closest('.cart-item, .pdp__cta, .pdp__qty');
            if (!wrap) return;
            const input = wrap.querySelector('[data-qty-input]');
            if (!input) return;
            const maxAttr = input.getAttribute('max');
            const max = maxAttr ? parseInt(maxAttr, 10) : null;
            let v = parseInt(input.value, 10) || 1;
            if (dec) v = Math.max(0, v - 1);
            if (inc) {
                if (max != null && v >= max) return;
                v = v + 1;
                if (max != null && v > max) v = max;
            }
            input.value = v;
            updateQtyButtonsState(input);
            if (input.dataset.key) {
                scheduleCartUpdate(input.dataset.key, v);
            }
        }
        if (rem) {
            const key = rem.dataset.key;
            if (key) {
                clearTimeout(cartUpdateTimers.get(key));
                cartUpdateTimers.delete(key);
                await changeCartItem(key, 0);
                document.querySelectorAll('[data-cart-item][data-key="' + key + '"]').forEach(el => el.remove());
                const fresh = await fetchCart();
                if (fresh.item_count === 0 && document.body.classList.contains('template-cart')) {
                    window.location.reload();
                    return;
                }
                refreshCart();
            }
        }
    });

    document.addEventListener('change', (e) => {
        const input = e.target.closest('[data-qty-input]');
        if (input) {
            const maxAttr = input.getAttribute('max');
            const max = maxAttr ? parseInt(maxAttr, 10) : null;
            let v = Math.max(0, parseInt(input.value, 10) || 0);
            if (max != null && v > max) v = max;
            input.value = v;
            updateQtyButtonsState(input);
            if (input.dataset.key) {
                scheduleCartUpdate(input.dataset.key, v);
            }
        }
    });

    function updateQtyButtonsState(input) {
        const wrap = input.closest('.pdp__qty, .cart-item__qty');
        if (!wrap) return;
        const inc = wrap.querySelector('[data-qty-increase]');
        const dec = wrap.querySelector('[data-qty-decrease]');
        const maxAttr = input.getAttribute('max');
        const max = maxAttr ? parseInt(maxAttr, 10) : null;
        const minAttr = input.getAttribute('min');
        const min = minAttr ? parseInt(minAttr, 10) : 0;
        const v = parseInt(input.value, 10) || 0;
        if (inc) {
            const atMax = max != null && v >= max;
            inc.disabled = atMax;
            inc.classList.toggle('is-disabled', atMax);
        }
        if (dec) {
            const atMin = v <= min;
            dec.disabled = atMin;
            dec.classList.toggle('is-disabled', atMin);
        }
    }

    document.querySelectorAll('[data-qty-input]').forEach(updateQtyButtonsState);

    /* ---------- Cart Note (debounced sync zu Shopify) ---------- */
    let noteUpdateTimer = null;
    document.addEventListener('input', (e) => {
        const note = e.target.closest('[data-cart-note]');
        if (!note) return;
        clearTimeout(noteUpdateTimer);
        noteUpdateTimer = setTimeout(async () => {
            try {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ note: note.value })
                });
                document.querySelectorAll('[data-cart-note]').forEach(other => {
                    if (other !== note) other.value = note.value;
                });
            } catch (err) {
                console.warn('Cart note update failed', err);
            }
        }, 500);
    });

    /* ---------- Drawer Section Reload via Shopify Section-Rendering-API ---------- */
    async function refreshDrawerSection() {
        try {
            const url = window.location.pathname + '?sections=cart-drawer';
            const res = await fetch(url, { credentials: 'same-origin' });
            if (!res.ok) throw new Error('Section API failed');
            const data = await res.json();
            const html = data['cart-drawer'];
            if (!html) return;
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('.cart-drawer');
            const oldDrawer = document.querySelector('.cart-drawer');
            if (newDrawer && oldDrawer) {
                const wasOpen = oldDrawer.classList.contains('is-open');
                oldDrawer.replaceWith(newDrawer);
                if (wasOpen) newDrawer.classList.add('is-open');
                newDrawer.querySelectorAll('[data-qty-input]').forEach(updateQtyButtonsState);
            }
        } catch (err) {
            console.warn('Drawer section refresh failed', err);
        }
    }

    async function refreshCartPageSection() {
        const oldPage = document.querySelector('.cart-page');
        if (!oldPage) return;
        try {
            const res = await fetch('/cart', { credentials: 'same-origin', cache: 'no-store' });
            if (!res.ok) return;
            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newPage = doc.querySelector('.cart-page');
            if (newPage) oldPage.replaceWith(newPage);
        } catch (err) {
            console.warn('Cart-page refresh failed', err);
        }
    }

    /* ---------- Quick-Add (Produkt-Card) + PDP-Form ---------- */
    document.addEventListener('submit', async (e) => {
        const form = e.target.closest('[data-quick-add], .pdp__form, form[action$="/cart/add"]');
        if (!form) return;
        e.preventDefault();
        const data = new FormData(form);
        const requestedQty = parseInt(data.get('quantity'), 10) || 1;
        const inv = await checkInventory(form, requestedQty);
        if (!inv.ok) {
            showCartError(inv.message);
            return;
        }
        const result = await addToCart(data);
        if (!result.ok) {
            showCartError(parseAddError(result.data));
            return;
        }
        productCache.delete(getFormHandle(form));
        pulseCart('bump');
        await refreshDrawerSection();
        await refreshCartPageSection();
        await refreshCart();

        // Upsell-Popup: matchende Regel zum gerade hinzugefuegten Produkt?
        const addedId = result.data && (result.data.product_id || result.data.id);
        const cartNow = await fetchCart();
        const rule = findMatchingUpsell(cartNow, addedId);
        if (rule && !upsellSeen(rule)) {
            markUpsellSeen(rule);
            showUpsellModal(rule, cartNow);
        } else {
            openCart();
        }
    });

    /* ---------- Mobile-Menu ---------- */
    const mobileMenu = $('[data-mobile-menu]');
    let lastFocusBeforeMenu = null;
    function openMobileMenu() {
        if (!mobileMenu) return;
        mobileMenu.classList.add('is-open');
        $$('[data-mobile-menu-toggle]').forEach(b => b.setAttribute('aria-expanded', 'true'));
        const panel = mobileMenu.querySelector('.mobile-menu__panel');
        if (panel) {
            panel.setAttribute('aria-modal', 'true');
            panel.setAttribute('role', 'dialog');
        }
        lockScroll();
        lastFocusBeforeMenu = document.activeElement;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const closeBtn = mobileMenu.querySelector('.mobile-menu__close, [data-mobile-menu-close]');
                if (closeBtn) closeBtn.focus();
            });
        });
    }
    function closeMobileMenu() {
        if (!mobileMenu) return;
        mobileMenu.classList.remove('is-open');
        $$('[data-mobile-menu-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
        const panel = mobileMenu.querySelector('.mobile-menu__panel');
        if (panel) panel.removeAttribute('aria-modal');
        unlockScroll();
        if (lastFocusBeforeMenu && typeof lastFocusBeforeMenu.focus === 'function') {
            lastFocusBeforeMenu.focus();
        }
    }
    $$('[data-mobile-menu-toggle]').forEach(b => b.addEventListener('click', e => {
        e.preventDefault();
        openMobileMenu();
    }));
    $$('[data-mobile-menu-close]').forEach(b => b.addEventListener('click', e => {
        e.preventDefault();
        closeMobileMenu();
    }));

    /* ---------- Scroll-Reveal (.reveal) ----------
       Dawn-Pattern: alles unterhalb des Viewports bekommt .reveal--offscreen
       (CSS haelt es unsichtbar). Beim Einscrollen faellt die Klasse weg und
       die CSS-Animation laeuft; --reveal-order staffelt Elemente, die im
       selben Observer-Durchlauf auftauchen (Kaskade). Elemente, die nur
       horizontal ausserhalb liegen (Slider-Cards) oder schon ueber dem
       Viewport sind, werden nicht versteckt. Was beim Laden bereits im
       Viewport ist, animiert direkt ab dem ersten Paint (ohne Stagger,
       sonst wuerde die laufende Animation neu starten). */
    (function initScrollReveal() {
        if (!('IntersectionObserver' in window)) return;
        if (document.body.classList.contains('is-design-mode')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const MARGIN = 40;      // px: Element muss so weit im Viewport sein
        const MAX_ORDER = 10;   // Deckel fuer die Staffelung (10 * 75ms)
        let observer = null;

        function onIntersect(entries) {
            let order = 0;
            entries.forEach((entry) => {
                const el = entry.target;
                if (entry.isIntersecting) {
                    if (el.classList.contains('reveal--offscreen')) {
                        el.style.setProperty('--reveal-order', String(Math.min(order++, MAX_ORDER)));
                        el.classList.remove('reveal--offscreen');
                    }
                    observer.unobserve(el);
                    return;
                }
                const r = entry.boundingClientRect;
                const belowFold = r.top >= window.innerHeight - MARGIN;
                const horizontallyOff = r.right <= 0 || r.left >= window.innerWidth;
                if (belowFold && !horizontallyOff) {
                    el.classList.add('reveal--offscreen');
                } else {
                    observer.unobserve(el);
                }
            });
        }

        function observeAll(root) {
            const els = $$('.reveal', root || document);
            if (!els.length) return;
            if (!observer) {
                observer = new IntersectionObserver(onIntersect, { rootMargin: '0px 0px -' + MARGIN + 'px 0px' });
            }
            els.forEach((el) => observer.observe(el));
        }

        // Nach der Animation Klasse entfernen: kein transform-Rest, Hover-Lift
        // (Product-Card) und fixed-Kinder funktionieren wieder normal.
        document.addEventListener('animationend', (e) => {
            if (e.animationName !== 'reveal-up') return;
            const el = e.target;
            if (!el.classList || !el.classList.contains('reveal')) return;
            el.classList.remove('reveal', 'reveal--offscreen');
            el.classList.add('is-revealed');
            el.style.removeProperty('--reveal-order');
        });

        observeAll();
        window.Shrimp = window.Shrimp || {};
        window.Shrimp.observeReveal = observeAll;
    })();

    /* ---------- Topbar-Dropdown (Über uns) ---------- */
    (function initTopbarMenu() {
        const menus = $$('[data-topbar-menu]');
        if (!menus.length) return;
        function closeAll(except) {
            menus.forEach(m => {
                if (m === except) return;
                m.classList.remove('is-open');
                const t = $('[data-topbar-menu-trigger]', m);
                if (t) t.setAttribute('aria-expanded', 'false');
            });
        }
        menus.forEach(menu => {
            const trigger = $('[data-topbar-menu-trigger]', menu);
            if (!trigger) return;
            trigger.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                const willOpen = !menu.classList.contains('is-open');
                closeAll(menu);
                menu.classList.toggle('is-open', willOpen);
                trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            });
        });
        document.addEventListener('click', e => {
            if (e.target.closest('[data-topbar-menu]')) return;
            closeAll(null);
        });
        document.addEventListener('keydown', e => {
            if (e.key !== 'Escape') return;
            const open = menus.find(m => m.classList.contains('is-open'));
            if (!open) return;
            closeAll(null);
            const t = $('[data-topbar-menu-trigger]', open);
            if (t) t.focus();
        });
    })();

    /* ---------- Topbar-USPs: mobil einzeln rotieren ---------- */
    (function initUspRotator() {
        const box = $('[data-usp-rotator]');
        if (!box) return;
        const items = $$('.site-header__usp', box);
        if (items.length < 2) return;

        const mqMobile = window.matchMedia('(max-width: 1024px)');
        const mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const DELAY = 4000;
        let index = 0;
        let timer = null;

        function show(i) {
            items.forEach((el, n) => el.classList.toggle('is-active', n === i));
        }
        function start() {
            if (timer) return;
            timer = window.setInterval(() => {
                index = (index + 1) % items.length;
                show(index);
            }, DELAY);
        }
        function stop() {
            if (!timer) return;
            window.clearInterval(timer);
            timer = null;
        }
        function enable() {
            box.classList.add('is-rotating');
            index = 0;
            show(index);
            start();
        }
        function disable() {
            stop();
            box.classList.remove('is-rotating');
            items.forEach(el => el.classList.remove('is-active'));
        }
        function sync() {
            if (mqMobile.matches && !mqReduced.matches) enable();
            else disable();
        }

        const onChange = () => sync();
        if (mqMobile.addEventListener) {
            mqMobile.addEventListener('change', onChange);
            mqReduced.addEventListener('change', onChange);
        } else if (mqMobile.addListener) {
            mqMobile.addListener(onChange);
            mqReduced.addListener(onChange);
        }
        document.addEventListener('visibilitychange', () => {
            if (!box.classList.contains('is-rotating')) return;
            if (document.hidden) stop();
            else start();
        });

        sync();
    })();

    /* ---------- Mobile-Menü: Accordion in Quick-Actions ---------- */
    (function initMobileAccordions() {
        $$('[data-mobile-acc]').forEach(group => {
            const trigger = $('[data-mobile-acc-trigger]', group);
            const panel = $('[data-mobile-acc-panel]', group);
            if (!trigger || !panel) return;
            trigger.addEventListener('click', e => {
                e.preventDefault();
                const willOpen = panel.hasAttribute('hidden');
                if (willOpen) {
                    panel.removeAttribute('hidden');
                } else {
                    panel.setAttribute('hidden', '');
                }
                group.classList.toggle('is-open', willOpen);
                trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            });
        });
    })();

    /* ---------- ESC + Focus-Trap für Modals ---------- */
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const drawer = getDrawer();
        if (drawer && drawer.classList.contains('is-open')) { closeCart(); return; }
        if (mobileMenu && mobileMenu.classList.contains('is-open')) { closeMobileMenu(); return; }
    });
    function trapFocus(container, e) {
        if (e.key !== 'Tab') return;
        const focusables = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        const active = document.activeElement;
        if (!container.contains(active)) {
            e.preventDefault();
            (e.shiftKey ? last : first).focus();
            return;
        }
        if (e.shiftKey && active === first) {
            e.preventDefault(); last.focus();
        } else if (!e.shiftKey && active === last) {
            e.preventDefault(); first.focus();
        }
    }
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab') return;
        const drawer = getDrawer();
        if (drawer && drawer.classList.contains('is-open')) {
            const panel = drawer.querySelector('.cart-drawer__panel');
            if (panel) trapFocus(panel, e);
            return;
        }
        if (mobileMenu && mobileMenu.classList.contains('is-open')) {
            const panel = mobileMenu.querySelector('.mobile-menu__panel');
            if (panel) trapFocus(panel, e);
        }
    }, true);

    /* ---------- Mobile-Menu: Produkt-Strips (Bestseller + Beliebt) Pfeil-Scroll ---------- */
    (function initMobileStrips() {
        const wraps = $$('[data-strip]');
        if (!wraps.length) return;

        function setup(wrap) {
            const track = $('[data-strip-track]', wrap);
            const prev = $('[data-strip-prev]', wrap);
            const next = $('[data-strip-next]', wrap);
            if (!track) return;

            function step() {
                const card = $('.mobile-menu__best-card', track);
                const cw = card ? card.offsetWidth + 10 : 0;
                return Math.max(cw * 1.5, track.clientWidth * 0.6);
            }
            function update() {
                const max = track.scrollWidth - track.clientWidth - 1;
                const scrollable = track.scrollWidth > track.clientWidth + 4;
                wrap.classList.toggle('is-scrollable', scrollable);
                if (prev) prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
                if (next) next.classList.toggle('is-disabled', track.scrollLeft >= max);
            }
            wrap._update = update;

            if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
            if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
            track.addEventListener('scroll', update, { passive: true });
            update();
        }

        wraps.forEach(setup);

        const updateAll = () => wraps.forEach(w => w._update && w._update());

        // Neu messen wenn Kategorie aufklappt (Details-Inhalt war vorher display:none → clientWidth 0)
        const navDetails = $$('.mobile-menu__nav details');
        const LAST_CAT_KEY = 'shrimp_mobilemenu_lastcat';
        // Zuletzt geoeffnete Kategorie wiederherstellen (ueberlebt Seitenwechsel)
        let restoring = false;
        try {
            const last = localStorage.getItem(LAST_CAT_KEY);
            if (last) {
                const target = navDetails.find(d => d.dataset.cat === last);
                if (target) { restoring = true; target.open = true; restoring = false; }
            }
        } catch (e) {}
        const panel = $('.mobile-menu__panel');
        navDetails.forEach(d => d.addEventListener('toggle', () => {
            // Akkordeon: nur ein Menue offen, andere schliessen
            if (d.open) {
                navDetails.forEach(other => { if (other !== d) other.open = false; });
                // Merken, damit beim naechsten Burger-Oeffnen wieder offen
                if (!restoring) { try { localStorage.setItem(LAST_CAT_KEY, d.dataset.cat || ''); } catch (e) {} }
                // Geoeffnete Kategorie an den oberen Panel-Rand scrollen,
                // damit man nach dem Aufklappen nicht erst suchen/scrollen muss.
                // Nur bei echtem Klick (nicht beim localStorage-Restore nach Seitenwechsel).
                if (!restoring && panel) {
                    const summary = $('.mobile-menu__top', d);
                    if (summary) {
                        // sticky-Header (Menue + X) ueberdeckt sonst die Kategorie → um dessen Hoehe versetzen
                        const header = $('.mobile-menu__header', panel);
                        const headerH = header ? header.offsetHeight : 0;
                        // nach Akkordeon-Reflow messen
                        requestAnimationFrame(() => {
                            const top = summary.getBoundingClientRect().top - panel.getBoundingClientRect().top;
                            panel.scrollTo({ top: panel.scrollTop + top - headerH - 8, behavior: 'smooth' });
                        });
                    }
                }
            } else if (!restoring) {
                // Manuell zugeklappt → gemerkten Eintrag loeschen wenn es die aktive war
                try { if (localStorage.getItem(LAST_CAT_KEY) === d.dataset.cat) localStorage.removeItem(LAST_CAT_KEY); } catch (e) {}
            }
            const w = $('[data-strip]', d);
            if (w && w._update) w._update();
        }));
        // Neu messen nach Menü-Öffnen (Panel-Transition ~300ms)
        $$('[data-mobile-menu-toggle]').forEach(b => b.addEventListener('click', () => setTimeout(updateAll, 340)));
        window.addEventListener('resize', updateAll);
    })();

    /* ---------- Header-Cart: Wackel-Animation (Add + Scroll-Nudge) ---------- */
    function pulseCart(type) {
        const cls = type === 'nudge' ? 'is-nudge' : 'is-bump';
        $$('.site-header__action--cart').forEach(btn => {
            btn.classList.remove('is-bump', 'is-nudge');
            void btn.offsetWidth; // Reflow → Animation neu starten
            btn.classList.add(cls);
            const clear = () => btn.classList.remove(cls);
            btn.addEventListener('animationend', clear, { once: true });
            setTimeout(clear, 900); // Fallback falls animationend ausbleibt
        });
    }
    (function initCartNudge() {
        if (!$$('.site-header__action--cart').length) return;
        const MIN_GAP = 14000; // min. 14s zwischen Nudges
        let lastNudge = Date.now();
        let ticking = false;
        function hasItems() {
            const c = $('[data-cart-count]');
            return c && !c.hasAttribute('hidden') && parseInt(c.textContent, 10) > 0;
        }
        window.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            setTimeout(() => { ticking = false; }, 400);
            const now = Date.now();
            if (now - lastNudge < MIN_GAP || !hasItems()) return;
            lastNudge = now;
            pulseCart('nudge');
        }, { passive: true });
    })();

    /* ---------- PDP: Galerie (Thumbs + Pfeile + Counter + Cross-Fade) ---------- */
    (function initPdpGallery() {
        const main = $('#pdp-main-img');
        const overlay = $('#pdp-main-img-overlay');
        const thumbs = $$('[data-pdp-thumb]');
        if (!main || !thumbs.length) return;
        const counter = $('[data-pdp-counter]');
        const prev = $('[data-pdp-prev]');
        const next = $('[data-pdp-next]');
        const FADE_MS = 320;
        // Startindex vom aktiven Thumb uebernehmen — Liquid markiert das Bild
        // der vorselektierten Variante (?variant=...), nicht zwingend Bild 1.
        let idx = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
        let pendingSrc = null;
        let inTransition = false;

        /* cover-Flag kommt aus Liquid (data-pdp-cover am Thumb): Querformat/
           Quadrat fuellt die Buehne per object-fit cover, Hochkant bleibt
           contain. Muss synchron zum src auf Haupt- UND Overlay-Bild wechseln,
           sonst croppt die Kreuzblende kurz falsch. */
        function applyFade(newSrc, cover) {
            if (!overlay) {
                main.removeAttribute('srcset');
                main.removeAttribute('sizes');
                main.classList.toggle('is-cover', cover);
                main.src = newSrc;
                return;
            }
            if (inTransition) { pendingSrc = { src: newSrc, cover: cover }; return; }
            inTransition = true;
            const pre = new Image();
            const finish = () => {
                overlay.removeAttribute('srcset');
                overlay.classList.toggle('is-cover', cover);
                overlay.src = newSrc;
                requestAnimationFrame(() => overlay.classList.add('is-visible'));
                setTimeout(() => {
                    main.removeAttribute('srcset');
                    main.removeAttribute('sizes');
                    main.classList.toggle('is-cover', cover);
                    main.src = newSrc;
                    overlay.classList.remove('is-visible');
                    inTransition = false;
                    if (pendingSrc && pendingSrc.src !== newSrc) {
                        const next = pendingSrc; pendingSrc = null;
                        applyFade(next.src, next.cover);
                    } else {
                        pendingSrc = null;
                    }
                }, FADE_MS + 20);
            };
            pre.onload = finish;
            pre.onerror = finish;
            pre.src = newSrc;
        }

        function show(n) {
            idx = (n + thumbs.length) % thumbs.length;
            const t = thumbs[idx];
            if (!t) return;
            const newSrc = t.dataset.pdpThumb;
            thumbs.forEach(x => x.classList.remove('is-active'));
            t.classList.add('is-active');
            if (counter) counter.textContent = (idx + 1) + ' / ' + thumbs.length;
            if (!newSrc) return;
            if (newSrc === main.getAttribute('src')) return;
            applyFade(newSrc, t.dataset.pdpCover === '1');
        }

        thumbs.forEach((t, n) => t.addEventListener('click', () => show(n)));
        if (prev) prev.addEventListener('click', () => show(idx - 1));
        if (next) next.addEventListener('click', () => show(idx + 1));

        // Variantenwechsel springt zum Bild der Variante (dispatcht in syncVariant)
        document.addEventListener('pdp:goto-image', (e) => {
            const n = e.detail && e.detail.index;
            if (typeof n === 'number' && n >= 0 && n < thumbs.length && n !== idx) show(n);
        });

        // Keyboard arrow navigation when gallery focused
        const galleryWrap = main.closest('.pdp__main-image');
        if (galleryWrap) {
            galleryWrap.setAttribute('tabindex', '0');
            galleryWrap.setAttribute('aria-label', 'Produkt-Galerie — Pfeile zum Navigieren');
            galleryWrap.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
                else if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
            });
            // Touch swipe
            let touchStartX = 0;
            let touchStartY = 0;
            galleryWrap.addEventListener('touchstart', (e) => {
                if (!e.touches.length) return;
                touchStartX = e.touches[0].clientX;
                touchStartY = e.touches[0].clientY;
            }, { passive: true });
            galleryWrap.addEventListener('touchend', (e) => {
                if (!e.changedTouches.length) return;
                const dx = e.changedTouches[0].clientX - touchStartX;
                const dy = e.changedTouches[0].clientY - touchStartY;
                if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
                if (dx > 0) show(idx - 1); else show(idx + 1);
            }, { passive: true });
        }
    })();

    /* ---------- PDP: Vollbild-Lightbox ----------
       Eine Lightbox fuer beide Galerien. Die Bildliste kommt aus den
       Mobile-Slides: die werden fuer jedes Produktbild gerendert und stehen
       auch auf dem Desktop im DOM (dort nur per CSS ausgeblendet). Die
       Desktop-Thumbs taugen nicht als Quelle, weil sie bei nur einem
       Produktbild gar nicht erst ausgegeben werden.
       Das Overlay wird erst beim ersten Oeffnen gebaut. */
    (function initPdpLightbox() {
        const sources = $$('[data-pdp-full]');
        if (!sources.length) return;

        const items = sources.map((el) => ({
            src: el.dataset.pdpFull,
            alt: el.getAttribute('alt') || ''
        }));

        let box = null, imgEl = null, counterEl = null, closeBtn = null;
        let prevBtn = null, nextBtn = null;
        let idx = 0;
        let lastFocus = null;

        function build() {
            if (box) return;
            box = document.createElement('div');
            box.className = 'pdp-lb';
            box.hidden = true;
            box.setAttribute('role', 'dialog');
            box.setAttribute('aria-modal', 'true');
            box.setAttribute('aria-label', 'Produktbild in Vollbild');
            box.innerHTML =
                '<button type="button" class="pdp-lb__close" data-lb-close aria-label="Vollbild schliessen">' +
                    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
                '</button>' +
                (items.length > 1 ?
                    '<button type="button" class="pdp-lb__nav pdp-lb__nav--prev" data-lb-prev aria-label="Vorheriges Bild">' +
                        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>' +
                    '</button>' +
                    '<button type="button" class="pdp-lb__nav pdp-lb__nav--next" data-lb-next aria-label="Naechstes Bild">' +
                        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>' +
                    '</button>' : '') +
                '<div class="pdp-lb__stage" data-lb-stage><img class="pdp-lb__img" data-lb-img alt=""></div>' +
                (items.length > 1 ? '<span class="pdp-lb__counter" data-lb-counter></span>' : '');
            document.body.appendChild(box);

            imgEl = $('[data-lb-img]', box);
            counterEl = $('[data-lb-counter]', box);
            closeBtn = $('[data-lb-close]', box);
            prevBtn = $('[data-lb-prev]', box);
            nextBtn = $('[data-lb-next]', box);

            closeBtn.addEventListener('click', close);
            if (prevBtn) prevBtn.addEventListener('click', () => show(idx - 1));
            if (nextBtn) nextBtn.addEventListener('click', () => show(idx + 1));

            // Klick auf den Hintergrund schliesst, Klick aufs Bild nicht.
            box.addEventListener('click', (e) => {
                if (e.target === box || e.target.hasAttribute('data-lb-stage')) close();
            });


            // Wischen zwischen den Bildern
            let sx = 0, sy = 0;
            box.addEventListener('touchstart', (e) => {
                if (!e.touches.length) return;
                sx = e.touches[0].clientX;
                sy = e.touches[0].clientY;
            }, { passive: true });
            box.addEventListener('touchend', (e) => {
                if (!e.changedTouches.length || items.length < 2) return;
                const dx = e.changedTouches[0].clientX - sx;
                const dy = e.changedTouches[0].clientY - sy;
                if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
                show(dx > 0 ? idx - 1 : idx + 1);
            }, { passive: true });
        }

        function show(n) {
            idx = (n + items.length) % items.length;
            imgEl.src = items[idx].src;
            imgEl.alt = items[idx].alt;
            if (counterEl) counterEl.textContent = (idx + 1) + ' / ' + items.length;
        }

        function onKeydown(e) {
            if (e.key === 'Escape') { e.preventDefault(); close(); return; }
            if (e.key === 'ArrowLeft' && items.length > 1) { e.preventDefault(); show(idx - 1); return; }
            if (e.key === 'ArrowRight' && items.length > 1) { e.preventDefault(); show(idx + 1); return; }
            if (e.key !== 'Tab') return;
            // Fokus im Overlay halten, solange es offen ist.
            const focusables = [closeBtn, prevBtn, nextBtn].filter(Boolean);
            if (focusables.length < 2) { e.preventDefault(); focusables[0].focus(); return; }
            const first = focusables[0];
            const last = focusables[focusables.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }

        function open(n) {
            build();
            if (!box.hidden) return;
            lastFocus = document.activeElement;
            show(n);
            box.hidden = false;
            lockScroll();
            document.addEventListener('keydown', onKeydown);
            requestAnimationFrame(() => box.classList.add('is-open'));
            closeBtn.focus();
        }

        function close() {
            if (!box || box.hidden) return;
            box.classList.remove('is-open');
            document.removeEventListener('keydown', onKeydown);
            unlockScroll();
            const finish = () => { box.hidden = true; };
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
            else setTimeout(finish, 200);
            if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        }

        // Aktuell sichtbares Bild ermitteln. Mobil: der Slide, der gerade in
        // der Spur steht. Desktop: der aktive Thumb.
        function currentIndex() {
            const track = $('[data-pdp-gm-track]');
            if (track && track.offsetParent !== null && track.clientWidth) {
                return Math.round(track.scrollLeft / track.clientWidth);
            }
            const activeThumb = $('.pdp__thumb.is-active');
            if (activeThumb && activeThumb.dataset.pdpIndex) {
                return parseInt(activeThumb.dataset.pdpIndex, 10) || 0;
            }
            return 0;
        }

        $$('[data-pdp-zoom]').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                open(currentIndex());
            });
        });

        // Klick aufs Desktop-Hauptbild oeffnet ebenfalls.
        const mainImg = $('#pdp-main-img');
        if (mainImg) {
            mainImg.style.cursor = 'zoom-in';
            mainImg.addEventListener('click', () => open(currentIndex()));
        }

        /* Tippen auf ein Mobile-Slide oeffnet die Lightbox — aber nur, wenn
           wirklich getippt und nicht gewischt wurde. Sonst reisst jeder
           Bildwechsel das Vollbild auf. */
        const gmTrack = $('[data-pdp-gm-track]');
        if (gmTrack) {
            let tx = 0, ty = 0, moved = false;
            gmTrack.addEventListener('touchstart', (e) => {
                if (!e.touches.length) return;
                tx = e.touches[0].clientX;
                ty = e.touches[0].clientY;
                moved = false;
            }, { passive: true });
            gmTrack.addEventListener('touchmove', (e) => {
                if (!e.touches.length) return;
                if (Math.abs(e.touches[0].clientX - tx) > 10 || Math.abs(e.touches[0].clientY - ty) > 10) moved = true;
            }, { passive: true });
            $$('.pdp__gm-slide img', gmTrack).forEach((slideImg, n) => {
                slideImg.addEventListener('click', () => {
                    if (moved) return;
                    open(n);
                });
            });
        }
    })();

    /* ---------- PDP: Variant-Select via Radios + Dropdowns ---------- */
    const variantSelect = $('[data-variant-select]');

    function syncVariant() {
        if (!variantSelect) return;
        const checkedRadios = $$('[data-variant-option]:checked').map(r => r.value);
        const selectVals = $$('[data-variant-option-select]').map(s => s.value);
        const values = checkedRadios.concat(selectVals);
        if (!values.length) return;
        const matching = Array.from(variantSelect.options).find(opt => {
            const parts = opt.textContent.split(' / ').map(s => s.trim());
            if (parts.length !== values.length) return false;
            return values.every((v, i) => parts[i] === v);
        });
        if (matching) {
            variantSelect.value = matching.value;
            updateUnitPrice(matching);
            updateVariantPrice(matching);
            updateStock(matching);
            updateVariantImage(matching);
        }
    }

    // Galerie (Desktop + Mobile) auf das Bild der Variante springen lassen.
    // data-img-index kommt aus Liquid (variant.featured_image.position - 1)
    // und ist leer, wenn der Variante kein Bild zugewiesen ist.
    function updateVariantImage(option) {
        const raw = option.dataset.imgIndex;
        if (raw === undefined || raw === '') return;
        const i = parseInt(raw, 10);
        if (isNaN(i) || i < 0) return;
        document.dispatchEvent(new CustomEvent('pdp:goto-image', { detail: { index: i } }));
    }

    // Lagerbestand der gewaehlten Variante: Stock-Indikator, Mengen-Maximum
    // und Kaufen-Button. Schwellen spiegeln den Liquid-Block in
    // product-main.liquid (>10 gruen 80 %, >3 orange 40 %, >0 rot 18 %).
    function updateStock(option) {
        const d = option.dataset;
        const available = d.available === 'true';
        const managed = d.invManaged === 'true';
        const qty = parseInt(d.inv, 10) || 0;

        const stock = $('[data-pdp-stock]');
        if (stock) {
            let label = 'Auf Lager';
            let pct = 60;
            let state = 'high';
            if (!available) {
                label = 'Diese Variante ist ausverkauft';
                pct = 0;
                state = 'low';
            } else if (!managed) {
                pct = 75;
            } else if (qty > 10) {
                label = qty + ' auf Lager';
                pct = 80;
            } else if (qty > 3) {
                label = 'Nur noch ' + qty + ' auf Lager';
                pct = 40;
                state = 'mid';
            } else if (qty > 0) {
                label = 'Nur noch ' + qty + ' auf Lager';
                pct = 18;
                state = 'low';
            }
            stock.classList.remove('pdp__stock--high', 'pdp__stock--mid', 'pdp__stock--low');
            stock.classList.add('pdp__stock--' + state);
            const labelEl = $('[data-pdp-stock-label]', stock);
            const fill = $('[data-pdp-stock-fill]', stock);
            const ship = $('[data-pdp-stock-ship]', stock);
            if (labelEl) labelEl.textContent = label;
            if (fill) fill.style.width = pct + '%';
            if (ship) ship.hidden = !available;
        }

        // Mengen-Maximum nur bei Bestandsfuehrung ohne Ueberverkauf
        const qtyInput = $('.pdp__qty [data-qty-input]');
        if (qtyInput) {
            const wrap = qtyInput.closest('.pdp__qty');
            if (managed && d.invDeny === 'true' && available) {
                qtyInput.max = qty;
                if (wrap) wrap.dataset.qtyMax = qty;
                if ((parseInt(qtyInput.value, 10) || 1) > qty) {
                    qtyInput.value = qty;
                    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
            } else {
                qtyInput.removeAttribute('max');
                if (wrap) delete wrap.dataset.qtyMax;
            }
            updateQtyButtonsState(qtyInput);
        }

        // Kaufen-Buttons (Buybox + Sticky-Leiste) fuer ausverkaufte Variante sperren
        $$('[data-pdp-atc]').forEach(btn => {
            if (!btn.dataset.atcLabel) btn.dataset.atcLabel = btn.textContent.trim();
            btn.disabled = !available;
            btn.textContent = available ? btn.dataset.atcLabel : 'Ausverkauft';
        });
    }

    // Preis der gewaehlten Variante in Buybox und Sticky-Kaufleiste schreiben.
    // Bis hierher wurde bei Variantenwechsel nur der Grundpreis aktualisiert —
    // der Hauptpreis blieb auf dem Wert der ersten Variante stehen.
    function updateVariantPrice(option) {
        const cents = parseInt(option.dataset.price, 10);
        if (isNaN(cents)) return;
        const text = formatMoney(cents);
        const main = $('.pdp__price-current[data-price]');
        const sticky = $('[data-stickybar-price]');
        if (main) main.textContent = text;
        if (sticky) sticky.textContent = text;

        // Streichpreis + Spare-Badge der gewaehlten Variante nachziehen —
        // sonst bleibt der Wert der beim Seitenaufbau gerenderten Variante stehen.
        const compareCents = parseInt(option.dataset.comparePrice, 10) || 0;
        const hasDiscount = compareCents > cents;
        const compareEl = $('.pdp__price-compare[data-compare-price]');
        const saveEl = $('.pdp__save[data-save-badge]');
        if (compareEl) {
            compareEl.hidden = !hasDiscount;
            compareEl.textContent = hasDiscount ? formatMoney(compareCents) : '';
        }
        if (saveEl) {
            saveEl.hidden = !hasDiscount;
            if (hasDiscount) saveEl.textContent = 'Spare ' + formatMoney(compareCents - cents);
        }
    }

    // Grundpreis (PAngV) der gewaehlten Variante aktualisieren.
    // Inhalt aus data-up ist serverseitig erzeugt + vom Browser entity-dekodiert,
    // kein User-Input -> innerHTML hier unbedenklich.
    function updateUnitPrice(option) {
        const target = $('[data-unit-price]');
        if (!target || !option) return;
        const html = option.dataset.up || '';
        target.innerHTML = html;
        if (html) target.removeAttribute('hidden');
        else target.setAttribute('hidden', '');
    }

    $$('[data-variant-option]').forEach(radio => radio.addEventListener('change', syncVariant));
    $$('[data-variant-option-select]').forEach(sel => sel.addEventListener('change', syncVariant));

    /* ---------- PDP: Staffelrabatte ---------- */
    (function initPdpTiers() {
        const wrap = $('[data-pdp-tiers]');
        if (!wrap) return;
        const basePrice = parseInt(wrap.dataset.basePrice, 10) || 0;

        // Settings-Variante: aus JSON in DOM rendern
        if (wrap.dataset.tiersJson && !wrap.querySelector('[data-pdp-tier]')) {
            let tiers = [];
            try {
                tiers = JSON.parse(wrap.dataset.tiersJson);
            } catch (e) { tiers = []; }
            if (!Array.isArray(tiers) || tiers.length === 0) {
                wrap.style.display = 'none';
                return;
            }
            const skel = wrap.querySelector('.pdp__tiers-skeleton');
            if (skel) skel.remove();
            const firstMin = parseInt(tiers[0].min, 10) || 1;
            const baseLabelMax = firstMin > 1 ? '–' + (firstMin - 1) : '';
            wrap.insertAdjacentHTML('beforeend', `
                <label class="pdp__tier" data-pdp-tier data-min="1" data-pct="0">
                    <input type="radio" name="pdp_tier" value="0" checked>
                    <div class="pdp__tier-body">
                        <div class="pdp__tier-main">
                            <span class="pdp__tier-label">1${baseLabelMax} Tiere</span>
                            <span class="pdp__tier-price"><span class="pdp__tier-price-current">${formatMoney(basePrice)}</span> <span class="pdp__tier-price-unit">pro Tier</span></span>
                        </div>
                        <div class="pdp__tier-sub">Regulärer Preis</div>
                    </div>
                </label>
            `);
            tiers.forEach(t => {
                const min = parseInt(t.min, 10) || 0;
                const pct = parseInt(t.pct, 10) || 0;
                if (!min || !pct) return;
                // Abrunden wie Dealeasy (Rabatt pro Stueck in vollen Cent)
                const saved = Math.floor(basePrice * pct / 100);
                const tierPrice = basePrice - saved;
                const badge = t.badge ? `<span class="pdp__tier-badge">${t.badge}</span>` : '';
                const label = t.label || `Ab ${min} Tieren`;
                wrap.insertAdjacentHTML('beforeend', `
                    <label class="pdp__tier" data-pdp-tier data-min="${min}" data-pct="${pct}">
                        ${badge}
                        <input type="radio" name="pdp_tier" value="${min}">
                        <div class="pdp__tier-body">
                            <div class="pdp__tier-main">
                                <span class="pdp__tier-label">${label}</span>
                                <span class="pdp__tier-price">
                                    <span class="pdp__tier-price-compare">${formatMoney(basePrice)}</span>
                                    <span class="pdp__tier-price-current">${formatMoney(tierPrice)}</span>
                                    <span class="pdp__tier-price-unit">pro Tier</span>
                                </span>
                            </div>
                            <div class="pdp__tier-sub">
                                <span class="pdp__tier-discount">${pct} % Rabatt</span>
                                <span class="pdp__tier-saved">Du sparst ${formatMoney(saved)}</span>
                            </div>
                        </div>
                    </label>
                `);
            });
        }

        const tierEls = Array.from(wrap.querySelectorAll('[data-pdp-tier]'));
        const pdpForm = wrap.closest('.pdp__form') || document.querySelector('.pdp__form');
        const qtyInput = pdpForm ? pdpForm.querySelector('.pdp__qty [data-qty-input]') : document.querySelector('.pdp__qty [data-qty-input]');

        function highlightActive() {
            const qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
            let best = tierEls[0];
            tierEls.forEach(el => {
                const min = parseInt(el.dataset.min, 10) || 1;
                if (qty >= min) best = el;
            });
            tierEls.forEach(el => {
                const active = el === best;
                el.classList.toggle('is-active', active);
                const r = el.querySelector('input[type="radio"]');
                if (r) r.checked = active;
            });
        }

        tierEls.forEach(el => {
            el.addEventListener('click', () => {
                const min = parseInt(el.dataset.min, 10) || 1;
                if (qtyInput) {
                    qtyInput.value = min;
                    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
                }
                highlightActive();
            });
        });

        if (qtyInput) {
            qtyInput.addEventListener('input', highlightActive);
            qtyInput.addEventListener('change', highlightActive);
            // Re-sync wenn +/− Buttons clicken
            document.querySelectorAll('[data-qty-decrease], [data-qty-increase]').forEach(b => {
                b.addEventListener('click', () => setTimeout(highlightActive, 0));
            });
        }

        highlightActive();
    })();

    /* ---------- PDP: Sticky-Kaufleiste ----------
       Erscheint erst, wenn der normale Kaufen-Button nach OBEN aus dem Bild
       gescrollt ist — nicht schon beim Laden und nicht, wenn der Button noch
       weiter unten steht.

       Bewusst KEIN IntersectionObserver: bei schnellem Scrollen (Fling, Sprung
       per Anker) wechselt der Button von "unterhalb" direkt nach "oberhalb",
       ohne je als sichtbar abgetastet zu werden — isIntersecting bleibt durchweg
       false, es gibt keinen Zustandswechsel und damit keinen Callback.
       Die rAF-gedrosselte Scroll-Pruefung ist deterministisch und folgt dem
       Muster von initBackToTop().

       Kein matchMedia-Guard noetig: oberhalb 1024px haelt CSS die Leiste auf
       display:none, das Klassen-Umschalten laeuft dort ins Leere. */
    (function initPdpStickyBar() {
        const bar = $('[data-pdp-stickybar]');
        const cta = $('.pdp__cta');
        if (!bar || !cta) return;

        let ticking = false;

        function update() {
            ticking = false;
            bar.classList.toggle('is-visible', cta.getBoundingClientRect().bottom < 0);
        }

        window.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(update);
        }, { passive: true });

        update();
    })();

    /* ---------- PDP: Akkordeons ohne Scroll-Sprung ----------
       Beim Auf- und Zuklappen soll die angeklickte Ueberschrift genau da
       stehen bleiben, wo sie war. CSS overflow-anchor deckt das in
       Chrome/Edge ab, Safari kennt die Eigenschaft nicht — deshalb hier
       die Position des Summary vor und nach dem Toggle vergleichen und
       die Differenz wegscrollen.

       Eine einzelne Messung im naechsten Frame reicht nicht: das
       Gewaehrleistungs-Akkordeon enthaelt eine grosse Label-Grafik, deren
       Layout Safari erst ein paar Frames spaeter final berechnet. Deshalb
       wird der Anker rund 600 ms nachgefuehrt und dabei jede erneute
       Verschiebung ausgeglichen. Scrollt der Nutzer selbst, wird sofort
       abgebrochen, damit die Korrektur ihm nicht in die Quere kommt. */
    (function initPdpAccordionScroll() {
        const wrap = $('.pdp__accordions');
        if (!wrap) return;

        const MAX_FRAMES = 36;          // ~600 ms bei 60 fps
        const GLIDE_MS = 320;
        const media = $('.pdp__media');
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        let anchor = null;              // { el, top }
        let frames = 0;
        let mediaTop = null;            // Galerie-Position beim Klick
        let glided = false;

        /* Die Galerie klebt per position:sticky und wird am Ende der rechten
           Spalte nach oben weggeschoben. Waechst die Spalte durch ein
           geoeffnetes Akkordeon, loest sich die Klemmung und die Galerie
           schnappt bis zu 480 px nach unten. Layout laesst sich das nicht
           abfangen — deshalb per FLIP: optisch an der alten Stelle starten
           und weich an die neue Position fahren. */
        function clearGlide() {
            media.style.transition = '';
            media.style.transform = '';
        }

        function glideMedia() {
            if (!media || mediaTop === null || reduceMotion.matches) return;
            const delta = mediaTop - media.getBoundingClientRect().top;
            if (Math.abs(delta) < 2) return;

            media.style.transition = 'none';
            media.style.transform = 'translateY(' + delta + 'px)';
            void media.offsetHeight;    // Reflow erzwingen
            media.style.transition = 'transform ' + GLIDE_MS + 'ms cubic-bezier(.22,.61,.36,1)';
            media.style.transform = 'translateY(0)';
            media.addEventListener('transitionend', clearGlide, { once: true });
        }

        function stop() {
            anchor = null;
            window.removeEventListener('wheel', stop);
            window.removeEventListener('touchmove', stop);
            window.removeEventListener('keydown', stop);
        }

        function follow() {
            if (!anchor) return;
            if (!glided) { glideMedia(); glided = true; }
            const diff = anchor.el.getBoundingClientRect().top - anchor.top;
            if (Math.abs(diff) > 1) {
                const before = window.scrollY;
                window.scrollBy(0, diff);
                // Am Dokumentende laesst sich nicht weiter scrollen (Browser
                // klemmt die Position beim Zuklappen). Dann den Anker
                // nachziehen, statt in jedem Frame erneut dagegen zu ziehen.
                if (window.scrollY === before) {
                    anchor.top = anchor.el.getBoundingClientRect().top;
                }
            }
            if (++frames < MAX_FRAMES) {
                requestAnimationFrame(follow);
            } else {
                stop();
            }
        }

        wrap.addEventListener('click', (e) => {
            const summary = e.target.closest('summary');
            if (!summary || !wrap.contains(summary)) return;

            if (media) {
                media.removeEventListener('transitionend', clearGlide);
                clearGlide();
                mediaTop = media.getBoundingClientRect().top;
            }
            glided = false;
            anchor = { el: summary, top: summary.getBoundingClientRect().top };
            frames = 0;
            window.addEventListener('wheel', stop, { passive: true, once: true });
            window.addEventListener('touchmove', stop, { passive: true, once: true });
            window.addEventListener('keydown', stop, { once: true });
            requestAnimationFrame(follow);
        });
    })();

    /* ---------- PDP: Mobile-Galerie (Scroll-Snap + Dots) ----------
       Eigene Spur, unabhaengig von initPdpGallery(). Oberhalb 1024px ist
       .pdp__gallery-mobile per CSS display:none, die Logik laeuft dort ins Leere. */
    (function initPdpMobileGallery() {
        const track = $('[data-pdp-gm-track]');
        if (!track) return;
        const slides = $$('.pdp__gm-slide', track);
        const dots = $$('[data-pdp-gm-dot]');
        if (!slides.length) return;

        // Startindex vom aktiven Dot: Liquid markiert das Bild der
        // vorselektierten Variante (?variant=...), nicht zwingend Bild 1.
        let current = Math.max(0, dots.findIndex(d => d.classList.contains('is-active')));

        function setActive(i) {
            current = i;
            dots.forEach((d, n) => {
                d.classList.toggle('is-active', n === i);
                // Punkte weiter weg vom aktiven schrumpfen (CSS liest --dist).
                d.style.setProperty('--dist', Math.min(Math.abs(n - i), 3));
            });
        }
        setActive(current);
        // Spur ohne Animation auf das Startbild stellen (nur wenn mobil sichtbar)
        if (current > 0 && track.clientWidth) {
            track.scrollLeft = current * track.clientWidth;
        }

        if ('IntersectionObserver' in window && dots.length) {
            const io = new IntersectionObserver((entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) setActive(slides.indexOf(e.target));
                });
            }, { root: track, threshold: 0.6 });
            slides.forEach((s) => io.observe(s));
        }

        /* ---- Autoplay: alle 4 Sekunden ein Bild weiter ----
           Laeuft nur mobil, nur im sichtbaren Bereich und nur solange der
           Nutzer nicht selbst bedient hat. Sobald jemand wischt, tippt oder
           die Pfeile nutzt, bleibt die Galerie dauerhaft manuell — eine
           Automatik, die gegen den Nutzer arbeitet, ist schlimmer als keine. */
        const mqMobile = window.matchMedia('(max-width: 1024px)');
        const mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        let userTook = false;
        let inView = true;

        function stopAutoplay() { userTook = true; }

        // Unterscheidet eigenen von fremdem Scroll: waehrend goTo() laeuft,
        // stammt jedes scroll-Ereignis von uns.
        let selfScrollUntil = 0;

        function goTo(i) {
            selfScrollUntil = Date.now() + 800;
            track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        }

        dots.forEach((dot, i) => {
            dot.addEventListener('click', () => {
                stopAutoplay();
                goTo(i);
            });
        });

        const gmPrev = $('[data-pdp-gm-prev]');
        const gmNext = $('[data-pdp-gm-next]');
        if (gmPrev) gmPrev.addEventListener('click', () => {
            stopAutoplay();
            track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
        });
        if (gmNext) gmNext.addEventListener('click', () => {
            stopAutoplay();
            track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        });

        // Variantenwechsel springt zum Bild der Variante (dispatcht in syncVariant)
        document.addEventListener('pdp:goto-image', (e) => {
            const n = e.detail && e.detail.index;
            if (typeof n !== 'number' || n < 0 || n >= slides.length || n === current) return;
            stopAutoplay();
            setActive(n);
            if (track.clientWidth) goTo(n);
        });

        if (slides.length > 1) {
            /* Stopp erst beim echten Wischen, nicht schon bei Beruehrung: ein
               Tipper aufs Bild soll den Bildwechsel nicht dauerhaft beenden.
               Ausgewertet wird deshalb der Scroll der Spur — alles, was nicht
               aus goTo() stammt, kommt vom Nutzer. */
            track.addEventListener('scroll', () => {
                if (Date.now() < selfScrollUntil) return;
                stopAutoplay();
            }, { passive: true });

            if ('IntersectionObserver' in window) {
                const visIo = new IntersectionObserver((entries) => {
                    inView = entries[0].isIntersecting;
                }, { threshold: 0.4 });
                visIo.observe(track);
            }

            setInterval(() => {
                if (userTook || document.hidden || !inView) return;
                if (!mqMobile.matches || mqReduce.matches) return;
                goTo((current + 1) % slides.length);
            }, 4000);
        }
    })();

    /* ---------- PDP: Lieferzeile mit konkreten Wochentagen ----------
       Bewusst clientseitig: Shopify cached die gerenderte Seite, ein
       serverseitig gerendertes Datum waere schnell veraltet.
       Versand geht Mo–Do (siehe Versand-Akkordeon), Zustellung Mo–Fr. */
    (function initPdpDelivery() {
        const box = $('[data-pdp-delivery]');
        const out = box && box.querySelector('[data-pdp-delivery-text]');
        if (!out) return;

        const leadMin = parseInt(box.dataset.leadMin, 10) || 1;
        const leadMax = parseInt(box.dataset.leadMax, 10) || leadMin;

        // Naechster Versandtag: Mo–Do, sonst der kommende Montag.
        const ship = new Date();
        while (ship.getDay() === 0 || ship.getDay() === 5 || ship.getDay() === 6) {
            ship.setDate(ship.getDate() + 1);
        }

        function addWorkdays(from, days) {
            const d = new Date(from);
            let left = days;
            while (left > 0) {
                d.setDate(d.getDate() + 1);
                if (d.getDay() !== 0 && d.getDay() !== 6) left -= 1;
            }
            return d;
        }

        const fmtDay = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric' });
        const fmtFull = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });

        const from = addWorkdays(ship, leadMin);
        const to = addWorkdays(ship, leadMax);

        out.textContent = from.getTime() === to.getTime()
            ? `Lieferung ${fmtFull.format(from)}`
            : `Lieferung ${fmtDay.format(from)} – ${fmtFull.format(to)}`;
    })();

    /* ---------- PDP: Slider (Cross-Sell + Curated) ---------- */
    function initPdpSlider(slider) {
        const key = slider.dataset.pdpSlider;
        const track = slider.querySelector('[data-pdp-slider-track]');
        if (!track) return;
        const prev = document.querySelector(`[data-pdp-slider-prev="${key}"]`);
        const next = document.querySelector(`[data-pdp-slider-next="${key}"]`);

        function step() {
            const slide = track.querySelector('.pdp-slider__slide');
            if (!slide) return track.clientWidth * 0.8;
            const styles = window.getComputedStyle(track);
            const gap = parseFloat(styles.columnGap || styles.gap || 16);
            return slide.getBoundingClientRect().width + gap;
        }
        function updateBtns() {
            if (!prev || !next) return;
            prev.disabled = track.scrollLeft <= 4;
            next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        }
        if (prev) prev.addEventListener('click', () => { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
        if (next) next.addEventListener('click', () => { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
        track.addEventListener('scroll', updateBtns, { passive: true });
        setTimeout(updateBtns, 100);
    }

    function equalizeCardTitles(scope) {
        if (!scope) return;
        const titles = scope.querySelectorAll('.product-card__title');
        if (!titles.length) return;
        titles.forEach(t => { t.style.minHeight = ''; });
        let max = 0;
        titles.forEach(t => { max = Math.max(max, t.getBoundingClientRect().height); });
        titles.forEach(t => { t.style.minHeight = max + 'px'; });
    }

    function equalizeAll() {
        $$('[data-pdp-slider] .pdp-slider__track').forEach(equalizeCardTitles);
        $$('.product-grid').forEach(equalizeCardTitles);
    }

    let resizeT = null;
    window.addEventListener('resize', () => {
        clearTimeout(resizeT);
        resizeT = setTimeout(equalizeAll, 120);
    }, { passive: true });

    $$('[data-pdp-slider="curated"]').forEach(slider => {
        initPdpSlider(slider);
        equalizeCardTitles(slider.querySelector('.pdp-slider__track'));
    });
    $$('.product-grid').forEach(equalizeCardTitles);

    /* ---------- PDP/Cart: Auto-Recommendations laden ---------- */
    $$('[data-pdp-slider="auto"], [data-pdp-slider="cart-rec"]').forEach(slider => {
        const url = slider.dataset.recommendationsUrl;
        const wrap = slider.closest('.pdp__crosssell-wrap, .cart-page__recommendations');
        if (!url) return;
        fetch(url)
            .then(r => r.text())
            .then(html => {
                const tmp = document.createElement('div');
                tmp.innerHTML = html.trim();
                const track = tmp.querySelector('[data-pdp-slider-track]');
                if (!track || !track.children.length) {
                    if (wrap) wrap.style.display = 'none';
                    return;
                }
                slider.innerHTML = '';
                slider.appendChild(track);
                initPdpSlider(slider);
                syncWishlistButtons();
                equalizeCardTitles(track);
            })
            .catch(() => { if (wrap) wrap.style.display = 'none'; });
    });

    /* ============================================================
       UPSELL-POPUPS (Kategorie-Regeln via Metaobjekt)
       ============================================================ */

    // Regeln aus dem Liquid-gerenderten JSON lesen (1x).
    const upsellRules = (function readUpsellRules() {
        const el = $('[data-upsell-rules]');
        if (!el) return [];
        try { return JSON.parse(el.textContent) || []; }
        catch (err) { console.warn('Upsell-Rules JSON ungueltig', err); return []; }
    })();
    window.Shrimp.upsellRules = upsellRules;

    // Summe der Cart-Mengen aller Produkte, deren product_id in triggerIds liegt.
    function triggerQtyInCart(cart, triggerIds) {
        const ids = (triggerIds || []).map(Number);
        return (cart.items || []).reduce((sum, item) => {
            return ids.includes(Number(item.product_id)) ? sum + item.quantity : sum;
        }, 0);
    }

    // Erste passende aktive Regel zum gerade hinzugefuegten Produkt.
    function findMatchingUpsell(cart, addedId) {
        if (!upsellRules.length || !addedId) return null;
        const added = Number(addedId);
        for (const rule of upsellRules) {
            const ids = (rule.triggerIds || []).map(Number);
            if (!ids.includes(added)) continue;        // nur direkt beim relevanten Add
            if (rule.condition === 'qty_below') {
                const qty = triggerQtyInCart(cart, rule.triggerIds);
                if (qty > 0 && qty < Number(rule.threshold || 0)) return rule;
            } else { // 'in_cart'
                return rule;
            }
        }
        return null;
    }

    // Session-Dedup: jede Regel max. 1x pro Browser-Session.
    function upsellSeenKey(rule) { return 'upsell_seen_' + rule.id; }
    function upsellSeen(rule) {
        try { return sessionStorage.getItem(upsellSeenKey(rule)) === '1'; }
        catch { return false; }
    }
    function markUpsellSeen(rule) {
        try { sessionStorage.setItem(upsellSeenKey(rule), '1'); }
        catch (err) { console.warn('Upsell sessionStorage nicht verfuegbar', err); }
    }

    /* ---------- Upsell-Modal Steuerung ---------- */
    function getUpsellModal() { return $('[data-upsell-modal]'); }
    let upsellLastFocus = null;

    function escapeHtml(str) {
        const d = document.createElement('div');
        d.textContent = str == null ? '' : String(str);
        return d.innerHTML;
    }

    function buildUpsellContent(rule) {
        let html = '';
        html += '<div class="upsell-modal__head">';
        html += '<h2 class="upsell-modal__title" id="upsell-modal-title">' + escapeHtml(rule.title) + '</h2>';
        html += '</div>';
        if (rule.body) {
            html += '<p class="upsell-modal__body">' + escapeHtml(rule.body).replace(/\n/g, '<br>') + '</p>';
        }

        if (rule.action === 'recommend_products' && rule.products && rule.products.length) {
            html += '<div class="upsell-modal__products">';
            rule.products.forEach(p => {
                if (!p.available) return;
                html += '<div class="upsell-product">';
                if (p.image) {
                    html += '<img class="upsell-product__img" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" width="64" height="64" loading="lazy">';
                }
                html += '<div class="upsell-product__info">';
                html += '<a class="upsell-product__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>';
                html += '<span class="upsell-product__price">' + escapeHtml(p.price) + '</span>';
                html += '</div>';
                html += '<button type="button" class="btn btn--primary upsell-product__add" data-upsell-add="' + p.variantId + '">' + escapeHtml(rule.ctaLabel || 'In den Warenkorb') + '</button>';
                html += '</div>';
            });
            html += '</div>';
            html += '<button type="button" class="upsell-modal__decline" data-upsell-close>Nein danke</button>';
        } else if (rule.action === 'increase_qty') {
            html += '<div class="upsell-modal__actions">';
            html += '<button type="button" class="btn btn--primary upsell-modal__cta" data-upsell-increase="' + Number(rule.threshold || 0) + '">' + escapeHtml(rule.ctaLabel || 'Menge erhöhen') + '</button>';
            html += '<button type="button" class="upsell-modal__decline" data-upsell-close>Nein danke</button>';
            html += '</div>';
        } else {
            html += '<button type="button" class="upsell-modal__decline upsell-modal__decline--solo" data-upsell-close>Verstanden</button>';
        }
        return html;
    }

    function showUpsellModal(rule, cart) {
        const modal = getUpsellModal();
        if (!modal) { openCart(); return; }
        const content = modal.querySelector('[data-upsell-content]');
        if (content) content.innerHTML = buildUpsellContent(rule);
        modal.dataset.upsellRuleTriggers = JSON.stringify(rule.triggerIds || []);
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        lockScroll();
        upsellLastFocus = document.activeElement;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const focusBtn = modal.querySelector('.btn--primary, [data-upsell-close]');
                if (focusBtn) focusBtn.focus();
            });
        });
    }

    function closeUpsellModal(thenOpenCart) {
        const modal = getUpsellModal();
        if (!modal) return;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        if (thenOpenCart !== false) {
            // Drawer uebernimmt den Scroll-Lock direkt -> kein unlock/relock-Sprung.
            openCart();          // ruft lockScroll() -> count 1->2
            if (typeof scrollLockCount === 'number') unlockScroll(); // count 2->1, body bleibt gesperrt
        } else {
            unlockScroll();
            if (upsellLastFocus && typeof upsellLastFocus.focus === 'function') upsellLastFocus.focus();
        }
    }

    // Klick-Handler innerhalb des Modals (delegiert).
    document.addEventListener('click', async (e) => {
        const modal = getUpsellModal();
        if (!modal || !modal.classList.contains('is-open')) return;

        // Schliessen / Nein danke
        if (e.target.closest('[data-upsell-close]')) {
            e.preventDefault();
            closeUpsellModal(true);
            return;
        }

        // Aktion: Empfohlenes Produkt hinzufuegen
        const addBtn = e.target.closest('[data-upsell-add]');
        if (addBtn) {
            e.preventDefault();
            addBtn.disabled = true;
            const fd = new FormData();
            fd.append('id', addBtn.dataset.upsellAdd);
            fd.append('quantity', '1');
            const res = await addToCart(fd);
            if (!res.ok) { addBtn.disabled = false; showCartError(parseAddError(res.data)); return; }
            await refreshDrawerSection();
            await refreshCartPageSection();
            await refreshCart();
            pulseCart('bump');
            closeUpsellModal(true);
            return;
        }

        // Aktion: Menge der Trigger-Produkte auf Schwelle erhoehen
        const incBtn = e.target.closest('[data-upsell-increase]');
        if (incBtn) {
            e.preventDefault();
            incBtn.disabled = true;
            const target = parseInt(incBtn.dataset.upsellIncrease, 10) || 0;
            let triggers = [];
            try { triggers = JSON.parse(modal.dataset.upsellRuleTriggers || '[]').map(Number); } catch {}
            const cart = await fetchCart();
            // Groesstes Trigger-Line-Item auf Zielmenge setzen
            const lines = (cart.items || []).filter(it => triggers.includes(Number(it.product_id)));
            if (lines.length) {
                lines.sort((a, b) => b.quantity - a.quantity);
                const main = lines[0];
                if (main.quantity < target) {
                    await changeCartItem(main.key, target);
                }
            }
            await refreshDrawerSection();
            await refreshCartPageSection();
            await refreshCart();
            pulseCart('bump');
            closeUpsellModal(true);
            return;
        }
    });

    // ESC schliesst Upsell-Modal (vor Drawer-Handler greift dieser zuerst, falls offen)
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const modal = getUpsellModal();
        if (modal && modal.classList.contains('is-open')) {
            e.stopPropagation();
            closeUpsellModal(true);
        }
    }, true);

    /* ---------- Init Shipping-Bar + Cross-Sell bei Page-Load ---------- */
    if ($('[data-shipping-bar]') || $('[data-cross-sell]')) {
        fetchCart().then(c => {
            detectTiersInCart(c);
            updateShippingBar(c.total_price);
            loadCrossSells(c);
        });
    }

    /* ============================================================
       WISHLIST (localStorage-basiert)
       ============================================================ */
    const WL_KEY = 'shrimp_wishlist_v1';
    const Wishlist = {
        all() {
            try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); }
            catch { return []; }
        },
        save(list) {
            try { localStorage.setItem(WL_KEY, JSON.stringify(list)); }
            catch (err) { console.warn('Wishlist save failed (quota?)', err); }
        },
        has(handle) { return this.all().some(p => p.handle === handle); },
        add(product) {
            const list = this.all();
            if (list.some(p => p.handle === product.handle)) return list;
            list.push(product);
            this.save(list);
            return list;
        },
        remove(handle) {
            const list = this.all().filter(p => p.handle !== handle);
            this.save(list);
            return list;
        },
        toggle(product) {
            return this.has(product.handle) ? this.remove(product.handle) : this.add(product);
        },
        count() { return this.all().length; }
    };
    window.Shrimp.wishlist = Wishlist;

    function updateWishlistCount() {
        const c = Wishlist.count();
        $$('[data-wishlist-count]').forEach(el => {
            el.textContent = c;
            if (c > 0) el.removeAttribute('hidden');
            else el.setAttribute('hidden', '');
        });
    }
    function syncWishlistButtons() {
        $$('[data-wishlist-toggle]').forEach(btn => {
            const handle = btn.dataset.productHandle;
            const active = Wishlist.has(handle);
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
            btn.setAttribute('aria-label', active ? 'Aus Wunschliste entfernen' : 'Zur Wunschliste hinzufügen');
            // Sichtbarer Text (z. B. PDP-Button) mitwechseln, Texte kommen aus data-label-add/-remove
            const label = btn.querySelector('[data-wishlist-label]');
            if (label) {
                label.textContent = active
                    ? (btn.dataset.labelRemove || 'Von der Wunschliste entfernen')
                    : (btn.dataset.labelAdd || 'Auf die Wunschliste');
            }
        });
    }
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-wishlist-toggle]');
        if (!btn) return;
        e.preventDefault();
        const product = {
            handle: btn.dataset.productHandle,
            title: btn.dataset.productTitle,
            url: btn.dataset.productUrl,
            image: btn.dataset.productImage,
            price: parseInt(btn.dataset.productPrice, 10) || 0,
            variant_id: btn.dataset.productVariant || '',
            available: btn.dataset.productAvailable !== 'false',
            note: btn.dataset.productNote || ''
        };
        Wishlist.toggle(product);
        syncWishlistButtons();
        updateWishlistCount();
        renderWishlistPage();
    });

    function renderWishlistPage() {
        const grid = $('[data-wishlist-grid]');
        const empty = $('[data-wishlist-empty]');
        const desc = $('[data-wishlist-desc]');
        if (!grid) return;
        const items = Wishlist.all();
        if (items.length === 0) {
            grid.setAttribute('hidden', '');
            grid.innerHTML = '';
            if (empty) empty.removeAttribute('hidden');
            if (desc) desc.textContent = 'Deine Wunschliste ist leer.';
            return;
        }
        if (empty) empty.setAttribute('hidden', '');
        if (desc) desc.textContent = `${items.length} ${items.length === 1 ? 'Produkt' : 'Produkte'} in deiner Wunschliste.`;
        grid.removeAttribute('hidden');

        // Sort: available first (in-stock vor ausverkauft), Reihenfolge sonst stabil
        const sorted = items
            .map((p, idx) => ({ p, idx }))
            .sort((a, b) => {
                const aAvail = a.p.available !== false ? 1 : 0;
                const bAvail = b.p.available !== false ? 1 : 0;
                if (aAvail !== bAvail) return bAvail - aAvail;
                return a.idx - b.idx;
            })
            .map(x => x.p);

        const escapeAttr = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const escapeHtml = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

        grid.innerHTML = sorted.map(p => {
            const variant = p.variant_id || '';
            const available = p.available !== false;
            const note = p.note || '';
            return `
            <article class="product-card${available ? '' : ' is-soldout'}">
                <a href="${escapeAttr(p.url)}" class="product-card__media">
                    ${p.image ? `<img src="${escapeAttr(p.image)}" alt="${escapeAttr(p.title)}" loading="lazy">` : ''}
                    ${available ? '' : '<span class="product-card__badge product-card__badge--soldout">Ausverkauft</span>'}
                    ${note ? `<span class="product-card__note${available ? ' product-card__note--top' : ''}">${escapeHtml(note)}</span>` : ''}
                </a>
                <button type="button" class="product-card__wishlist is-active" data-wishlist-toggle data-product-handle="${escapeAttr(p.handle)}" data-product-title="${escapeAttr(p.title)}" data-product-url="${escapeAttr(p.url)}" data-product-image="${escapeAttr(p.image)}" data-product-price="${escapeAttr(p.price)}" data-product-variant="${escapeAttr(variant)}" data-product-available="${available}" data-product-note="${escapeAttr(note)}" aria-label="Aus Wunschliste entfernen" aria-pressed="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>
                </button>
                <div class="product-card__body">
                    <h3 class="product-card__title"><a href="${escapeAttr(p.url)}">${escapeHtml(p.title)}</a></h3>
                    <div class="product-card__price"><span class="product-card__price-current">${formatMoney(p.price)}</span></div>
                    ${available && variant ? `
                        <form data-quick-add data-product-handle="${escapeAttr(p.handle)}">
                            <input type="hidden" name="id" value="${escapeAttr(variant)}">
                            <input type="hidden" name="quantity" value="1">
                            <button type="submit" class="product-card__atc">In den Warenkorb</button>
                        </form>
                    ` : `<button type="button" class="product-card__atc" disabled>Ausverkauft</button>`}
                </div>
            </article>
        `;}).join('');
    }

    /* Reorder Sold-Out Cards: bewegt .is-soldout ans Ende stabil.
       Banner-Cards (collection-banner-card oder [data-pin-position]) behalten
       ihre urspruengliche Position. */
    function reorderSoldOutCards(grid) {
        if (!grid) return;
        const allCards = Array.from(grid.children);
        const pinned = []; // {el, idx}
        const products = [];
        allCards.forEach((c, idx) => {
            if (c.classList.contains('collection-banner-card') || c.dataset.pinPosition !== undefined) {
                pinned.push({ el: c, idx });
            } else {
                products.push(c);
            }
        });
        const soldOut = products.filter(c => c.classList.contains('is-soldout'));
        const inStock = products.filter(c => !c.classList.contains('is-soldout'));
        if (!soldOut.length || !inStock.length) return;
        const sortedProducts = inStock.concat(soldOut);
        const final = [];
        let pi = 0;
        for (let i = 0; i < allCards.length; i++) {
            const banner = pinned.find(b => b.idx === i);
            if (banner) {
                final.push(banner.el);
            } else if (pi < sortedProducts.length) {
                final.push(sortedProducts[pi++]);
            }
        }
        const frag = document.createDocumentFragment();
        final.forEach(c => frag.appendChild(c));
        grid.appendChild(frag);
    }
    document.addEventListener('DOMContentLoaded', () => {
        $$('[data-soldout-reorder]').forEach(reorderSoldOutCards);
    });

    /* ---------- Preview-Theme-Param an interne Links anhaengen ----------
       Wenn URL ?preview_theme_id=XXX enthaelt, haengt der Param an alle
       internen Anchor-Klicks. Verhindert dass User den Preview-Modus
       verliert (z.B. beim Logo-Klick auf "/"). */
    (function preservePreviewParam() {
        const params = new URLSearchParams(window.location.search);
        const previewId = params.get('preview_theme_id');
        if (!previewId) return;
        document.addEventListener('click', (e) => {
            const a = e.target.closest('a[href]');
            if (!a) return;
            const href = a.getAttribute('href');
            if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
            try {
                const url = new URL(href, window.location.origin);
                if (url.origin !== window.location.origin) return;
                if (!url.searchParams.has('preview_theme_id')) {
                    url.searchParams.set('preview_theme_id', previewId);
                    a.setAttribute('href', url.pathname + url.search + url.hash);
                }
            } catch { /* ignore malformed URLs */ }
        }, true);
    })();

    /* Wishlist: Live-Refresh via Shopify Product JSON
       Holt fuer jedes gespeicherte Produkt aktuelle Verfuegbarkeit/Preis/Bild
       und persistiert Aenderungen in localStorage. */
    async function refreshWishlistItems() {
        const items = Wishlist.all();
        if (!items.length) return false;
        const results = await Promise.all(items.map(async p => {
            if (!p.handle) return { status: 'skip' };
            try {
                const r = await fetch('/products/' + encodeURIComponent(p.handle) + '.js', { credentials: 'same-origin' });
                if (r.status === 404) return { status: 'notfound' };
                if (!r.ok) return { status: 'error' };
                const data = await r.json();
                return { status: 'ok', data };
            } catch {
                return { status: 'error' };
            }
        }));
        let changed = false;
        const updated = items.map((p, i) => {
            const res = results[i];
            if (!res || res.status === 'error' || res.status === 'skip') return p;
            const np = Object.assign({}, p);
            if (res.status === 'notfound') {
                if (np.available !== false) { np.available = false; changed = true; }
                return np;
            }
            const fresh = res.data;
            if (typeof fresh.available === 'boolean' && fresh.available !== p.available) {
                np.available = fresh.available; changed = true;
            }
            if (typeof fresh.price === 'number' && fresh.price !== p.price) {
                np.price = fresh.price; changed = true;
            }
            if (fresh.featured_image && fresh.featured_image !== p.image) {
                np.image = fresh.featured_image; changed = true;
            }
            if (fresh.title && fresh.title !== p.title) {
                np.title = fresh.title; changed = true;
            }
            if (fresh.variants && fresh.variants.length) {
                const oldExists = fresh.variants.some(v => String(v.id) === String(p.variant_id));
                if (!oldExists) {
                    const firstAvail = fresh.variants.find(v => v.available) || fresh.variants[0];
                    if (firstAvail && String(firstAvail.id) !== String(p.variant_id)) {
                        np.variant_id = firstAvail.id; changed = true;
                    }
                }
            }
            return np;
        });
        if (changed) Wishlist.save(updated);
        return changed;
    }

    /* Init Wishlist UI */
    updateWishlistCount();
    syncWishlistButtons();
    renderWishlistPage();
    // Seite aus Back-Forward-Cache (v. a. iOS Safari): Button-Status neu einlesen
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) {
            syncWishlistButtons();
            updateWishlistCount();
        }
    });
    if ($('[data-wishlist-grid]')) {
        refreshWishlistItems().then(changed => {
            if (changed) {
                renderWishlistPage();
                updateWishlistCount();
                syncWishlistButtons();
            }
        });
    }

    /* ---------- Back-to-Top ---------- */
    /* ---------- Mobile-Header: klappt beim Scrollen ein ----------
       Ausgangszustand bleibt unveraendert, ab 80px Scroll faellt die
       USP-Leiste und das Suchfeld weg (186px -> ~52px). Rueckgaengig erst
       unter 40px — die Hysterese verhindert Flackern an der Schwelle.
       Oberhalb 1024px greifen die .is-condensed-Regeln nicht, die Klasse
       wird dort also nur mitgefuehrt und bleibt wirkungslos.

       Nebenaufgabe: schreibt die aktuelle Header-Hoehe nach --header-h,
       damit Anker-Offsets nicht mehr hart kodiert sein muessen. */
    (function initHeaderCondense() {
        const header = $('.site-header');
        if (!header) return;

        const CONDENSE_AT = 80;
        // Bewusst dicht am Seitenanfang: der Kopf klappt erst wieder auf, wenn
        // der Nutzer wirklich nach oben zurueck ist. Bei 40px sprang er schon
        // bei kleinen Korrekturbewegungen auf.
        const EXPAND_AT = 8;
        const UNPIN_DISTANCE = 150;
        // Produktseiten liefern den Kopf schon eingeklappt aus (header.liquid).
        // Dort bleibt er es auch am Seitenanfang — aufgeklappt wird nur ueber
        // die Lupe, sonst waere die serverseitige Entscheidung nach dem ersten
        // Scroll-Tick wieder hinfaellig.
        const startCondensed = header.classList.contains('is-condensed');
        let condensed = startCondensed;
        let ticking = false;

        // Der Kopf steckt als position:sticky im Dokumentfluss. Klappt er auf
        // oder zu, aendert sich seine Hoehe um rund 100px und alles darunter
        // verschiebt sich mit. Der Browser haelt den sichtbaren Inhalt per
        // Scroll-Anchoring fest und korrigiert dafuer die Scroll-Position um
        // genau diesen Betrag (gemessen: 200px -> 301px). Diese Korrektur ist
        // groesser als der Abstand der beiden Schwellen (80 - 8 = 72px) —
        // jeder Klappvorgang warf die Seite deshalb ueber die jeweils andere
        // Schwelle und loeste sofort den Gegenwechsel aus: der Kopf klappte
        // endlos hin und her. Sichtbar wurde das beim Back-to-Top, weil der
        // Sprung nach oben beide Schwellen in einem Zug durchfaehrt (auf iOS
        // Safari zusaetzlich angestossen durch die ausfahrende URL-Leiste).
        //
        // Zwei Gegenmittel: Anchoring waehrend der Hoehenanimation abschalten
        // (Safari kennt die Eigenschaft nicht und ignoriert sie folgenlos) und
        // danach eine kurze Ruhephase, in der kein Gegenwechsel greift. Erst
        // wenn die Hoehe steht, wird der Zustand neu bewertet.
        const SETTLE_MS = 500;   // 420ms --t-header + Puffer
        let settleTimer = null;
        let settling = false;

        function setCondensed(next) {
            if (next === condensed) return;
            condensed = next;
            document.documentElement.style.overflowAnchor = 'none';
            header.classList.toggle('is-condensed', next);
            settling = true;
            clearTimeout(settleTimer);
            settleTimer = setTimeout(() => {
                settling = false;
                document.documentElement.style.overflowAnchor = '';
                // Nach dem Klappen ist die Scroll-Position der neue Bezugspunkt,
                // sonst laese die Auto-Hide-Logik den Hoehensprung als Wischen.
                lastY = window.scrollY;
                update();
            }, SETTLE_MS);
        }

        // Auto-Hide (nur Desktop, CSS greift ab 1025px): ab HIDE_BELOW faehrt
        // der Kopf beim Runterscrollen weg und kommt beim Hochscrollen zurueck.
        // DELTA filtert Trackpad-Zittern, damit er nicht flackert.
        const section = header.closest('.shopify-section') || header;
        const HIDE_BELOW = 240;
        const DELTA = 5;
        let lastY = window.scrollY;
        let unpinned = false;

        function setUnpinned(next) {
            if (next === unpinned) return;
            unpinned = next;
            section.classList.toggle('is-unpinned', next);
        }
        // Solange die Suche bewusst aufgeklappt wurde, darf der Header nicht
        // wieder einklappen — sonst wuerde schon das Scrollen, das der
        // Eingabefokus selbst ausloest, die Suche sofort zuklappen.
        let searchPinnedAt = null;

        function publishHeight() {
            document.documentElement.style.setProperty(
                '--header-h', Math.round(header.getBoundingClientRect().height) + 'px'
            );
        }

        function update() {
            ticking = false;
            const y = window.scrollY;

            if (searchPinnedAt !== null) {
                if (Math.abs(y - searchPinnedAt) < UNPIN_DISTANCE) {
                    publishHeight();
                    return;
                }
                searchPinnedAt = null;
            }

            if (!settling) {
                if (!condensed && y > CONDENSE_AT) {
                    setCondensed(true);
                } else if (condensed && y < EXPAND_AT && !startCondensed) {
                    setCondensed(false);
                }
            }

            const dy = y - lastY;
            if (y <= HIDE_BELOW) {
                setUnpinned(false);
                lastY = y;
            } else if (dy > DELTA) {
                setUnpinned(true);
                lastY = y;
            } else if (dy < -DELTA) {
                setUnpinned(false);
                lastY = y;
            }

            publishHeight();
        }

        window.addEventListener('scroll', () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(update);
        }, { passive: true });

        window.addEventListener('resize', publishHeight, { passive: true });
        header.addEventListener('transitionend', publishHeight);

        // Lupe klappt den Header wieder auf und fokussiert das bestehende Suchfeld.
        const searchOpen = $('[data-header-search-open]');
        const searchInput = $('[data-predictive-input]');
        if (searchOpen) {
            searchOpen.addEventListener('click', () => {
                searchPinnedAt = window.scrollY;
                lastY = window.scrollY;
                setUnpinned(false);
                setCondensed(false);
                publishHeight();
                if (searchInput) setTimeout(() => searchInput.focus(), 220);
            });
        }
        if (searchInput) {
            // Auf Touch feuert blur, BEVOR der Tap auf einem Suchvorschlag zum
            // click wird. Klappte der Header sofort ein, verschwand das Suchfeld
            // samt Dropdown (max-height:0, pointer-events:none) und der Link
            // wurde nie ausgeloest — auf Produktseiten immer, weil der Kopf dort
            // eingeklappt startet. Deshalb kurz warten und nur einklappen, wenn
            // keine Vorschlaege mehr offen sind.
            let collapseTimer = null;
            searchInput.addEventListener('blur', () => {
                if (searchPinnedAt === null) return;
                clearTimeout(collapseTimer);
                collapseTimer = setTimeout(() => {
                    const results = $('[data-predictive-results]');
                    if (results && !results.hidden) return;
                    if (document.activeElement === searchInput) return;
                    searchPinnedAt = null;
                    if (startCondensed || window.scrollY > CONDENSE_AT) {
                        setCondensed(true);
                        publishHeight();
                    }
                }, 250);
            });
            searchInput.addEventListener('focus', () => clearTimeout(collapseTimer));
        }

        update();
    })();

    (function initBackToTop() {
        const btn = $('[data-back-to-top]');
        if (!btn) return;
        const threshold = 400;
        let ticking = false;

        // Das Markup liefert den Knopf mit [hidden] aus, damit er ohne
        // JavaScript gar nicht erst erscheint. Sobald das JS laeuft, wird das
        // Attribut einmalig entfernt und die Sichtbarkeit nur noch ueber
        // .is-visible gesteuert (visibility + pointer-events im CSS).
        // Grund: nimmt [hidden] den Knopf aus dem Layout und setzt ihn wieder
        // ein, verliert Chrome die fixed-Ebene — der Knopf bleibt dann an
        // seiner Dokumentposition im Footer haengen.
        btn.hidden = false;

        // Sichtbarkeitswechsel als Event melden, damit andere Elemente
        // (z. B. die Social-Feed-Lasche) exakt mit dem Knopf ein- und
        // ausblenden koennen, ohne eine zweite Scroll-Schwelle zu pflegen.
        let visible = false;

        function update() {
            const show = window.scrollY > threshold;
            btn.classList.toggle('is-visible', show);
            ticking = false;
            if (show !== visible) {
                visible = show;
                document.dispatchEvent(new CustomEvent('shrimp:backtotop', { detail: { visible: show } }));
            }
        }

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        }, { passive: true });

        btn.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });

        update();
    })();

    /* ---------- Mega-Menu: innerhalb des Fensters halten ----------
       Die Klappmenues haengen absolut an ihrer Kategorie und sind mit
       Produktkachel bis zu 880px breit. Bei acht Kategorien standen die
       mittleren so weit rechts, dass ihr Menue rechts aus dem Fenster ragte —
       gemessen bei 1440px Fensterbreite bis zu 192px. Weil auch ein
       geschlossenes Menue (visibility: hidden) Layoutflaeche belegt, hatte
       die Seite dadurch dauerhaft eine waagerechte Bildlaufleiste.

       Hier wird pro Menue gemessen und nur das noetige Stueck als
       --mega-shift zurueckgeschoben. Menues, die ohnehin passen, bleiben
       exakt unter ihrer Kategorie stehen. */
    (function initMegaMenuFit() {
        const menus = $$('.cat-item--has-mega .mega-menu');
        if (!menus.length) return;
        const GAP = 16; // Mindestabstand zum Fensterrand

        // Bewusst NICHT ueber getBoundingClientRect() des Menues messen: auf
        // .mega-menu liegt eine 200ms-Transition fuer transform. Ein direkt
        // nach dem Setzen gelesener Rechteckwert zeigt deshalb noch die alte,
        // wegtransformierte Position - die Korrektur fiel dadurch jedes Mal zu
        // klein aus. offsetLeft/offsetWidth ignorieren den transform des
        // Elements und liefern die unverschobene Sollposition.
        function fit() {
            const vw = document.documentElement.clientWidth;
            menus.forEach(menu => {
                const parent = menu.offsetParent;
                if (!parent) return;
                const pr = parent.getBoundingClientRect();
                const left = pr.left + parent.clientLeft + menu.offsetLeft;
                const right = left + menu.offsetWidth;
                let shift = 0;
                if (right > vw - GAP) shift = -(right - (vw - GAP));
                if (left + shift < GAP) shift = GAP - left;
                menu.style.setProperty('--mega-shift', Math.round(shift) + 'px');
            });
        }

        let raf = null;
        function schedule() {
            if (raf) return;
            raf = requestAnimationFrame(() => { raf = null; fit(); });
        }

        fit();
        window.addEventListener('resize', schedule);
        window.addEventListener('orientationchange', schedule);
        // Bilder in den Produktkacheln koennen die Zeile noch verschieben.
        window.addEventListener('load', schedule);
        // Webfonts aendern die Breite der Kategoriezeile und damit die
        // Startpositionen der Menues.
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(schedule).catch(() => {});
        }
    })();

    /* ---------- Mega-Menu: Tippen statt Hovern auf Touch-Geraeten ----------
       Im Querformat bekommen Smartphones und Tablets die Desktop-Ansicht
       (siehe Viewport-Skript in theme.liquid). Damit ist die
       Kategorie-Navigation sichtbar, ihre Mega-Menues oeffnen im CSS aber nur
       per :hover. Auf Touch gibt es keinen Hover: Android folgt sofort dem
       Link, iOS setzt einen Pseudo-Hover, der danach kleben bleibt.
       Deshalb hier explizit: erster Tipp oeffnet das Menue, zweiter Tipp auf
       dieselbe Kategorie folgt dem Link. Kategorien ohne Untermenue bleiben
       normale Links. */
    (function initMegaMenuTouch() {
        const items = $$('.cat-item--has-mega');
        if (!items.length) return;
        if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;

        function closeAll(except) {
            items.forEach(item => {
                if (item === except) return;
                item.classList.remove('is-open');
                const link = $('.cat-item__link', item);
                if (link) link.setAttribute('aria-expanded', 'false');
            });
        }

        items.forEach(item => {
            const link = $('.cat-item__link', item);
            if (!link) return;
            link.setAttribute('aria-haspopup', 'true');
            link.setAttribute('aria-expanded', 'false');

            link.addEventListener('click', e => {
                if (item.classList.contains('is-open')) return; // zweiter Tipp -> Link folgen
                e.preventDefault();
                closeAll(item);
                item.classList.add('is-open');
                link.setAttribute('aria-expanded', 'true');
            });
        });

        document.addEventListener('click', e => {
            if (!e.target.closest('.cat-item--has-mega')) closeAll(null);
        });
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') closeAll(null);
        });
    })();

    /* ---------- Orientierungswechsel: Overlays schliessen ----------
       Beim Drehen wechselt der Viewport zwischen Mobil- und Desktop-Breite.
       Ein offener Warenkorb-Drawer, das Burger-Menue oder der Filter-Dialog
       wuerden dabei in ein Layout gerendert, fuer das sie nicht gedacht sind —
       und der Scroll-Lock am body bliebe mit einer nicht mehr passenden
       Scroll-Position stehen. Alles offene wird deshalb sauber geschlossen. */
    (function initOrientationReset() {
        if (!window.matchMedia) return;
        const mq = window.matchMedia('(orientation: landscape)');

        function closeOverlays() {
            if (mobileMenu && mobileMenu.classList.contains('is-open')) closeMobileMenu();
            const drawer = getDrawer();
            if (drawer && drawer.classList.contains('is-open')) closeCart();
            const filter = $('[data-filter-drawer]');
            if (filter && filter.classList.contains('is-open')) {
                const close = $('[data-filter-close]', filter);
                if (close) close.click();
            }
        }

        if (mq.addEventListener) mq.addEventListener('change', closeOverlays);
        else if (mq.addListener) mq.addListener(closeOverlays);
    })();

    /* ---------- Mega-Menu Sublink-Swap ---------- */
    (function initMegaMenuSwap() {
        $$('[data-mega-menu]').forEach(menu => {
            const sublinks = $$('[data-mega-target]', menu);
            const groups = $$('[data-mega-group]', menu);
            if (sublinks.length === 0 || groups.length === 0) return;

            function activate(targetId) {
                sublinks.forEach(sl => {
                    sl.classList.toggle('is-active', sl.dataset.megaTarget === targetId);
                });
                groups.forEach(g => {
                    g.classList.toggle('is-active', g.dataset.megaGroup === targetId);
                });
            }

            sublinks.forEach(sl => {
                sl.addEventListener('mouseenter', () => activate(sl.dataset.megaTarget));
                sl.addEventListener('focus', () => activate(sl.dataset.megaTarget));
            });
        });
    })();

    /* ---------- Promo-Bar: Aktionscode kopieren ---------- */
    (function initPromoCopy() {
        const btns = $$('[data-promo-copy]');
        if (btns.length === 0) return;

        function fallbackCopy(text) {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.setAttribute('readonly', '');
            ta.style.position = 'absolute';
            ta.style.left = '-9999px';
            document.body.appendChild(ta);
            ta.select();
            let ok = false;
            try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
            document.body.removeChild(ta);
            return ok;
        }

        btns.forEach(btn => {
            const code = btn.dataset.promoCopy || '';
            const label = $('[data-promo-label]', btn);
            if (!code || !label) return;
            const original = label.textContent;
            let timer = null;

            function showCopied() {
                btn.classList.add('is-copied');
                label.textContent = 'Kopiert!';
                clearTimeout(timer);
                timer = setTimeout(() => {
                    btn.classList.remove('is-copied');
                    label.textContent = original;
                }, 1500);
            }

            btn.addEventListener('click', () => {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(code).then(showCopied).catch(() => {
                        if (fallbackCopy(code)) showCopied();
                    });
                } else if (fallbackCopy(code)) {
                    showCopied();
                }
            });
        });
    })();

    /* ---------- Promo-Bar: Schließen (Session) + Countdown ---------- */
    (function initPromoBar() {
        const bar = $('[data-promo-bar]');
        if (!bar) return;

        const STORE_KEY = 'promoDismissed';
        const key = bar.dataset.promoKey || '';

        /* Bereits in dieser Session geschlossen? -> Leiste nicht zeigen */
        try {
            if (key && sessionStorage.getItem(STORE_KEY) === key) {
                bar.hidden = true;
                return;
            }
        } catch (e) { /* sessionStorage blockiert -> einfach anzeigen */ }

        /* Schließen-Button */
        const closeBtn = $('[data-promo-close]', bar);
        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                bar.hidden = true;
                try { if (key) sessionStorage.setItem(STORE_KEY, key); } catch (e) {}
            });
        }

        /* Countdown */
        const timerEl = $('[data-promo-timer]', bar);
        const valEl = $('[data-promo-timer-val]', bar);
        const deadlineStr = bar.dataset.promoDeadline;
        if (timerEl && valEl && deadlineStr) {
            const deadline = new Date(deadlineStr).getTime();
            if (!isNaN(deadline)) {
                const pad = n => String(n).padStart(2, '0');

                function render() {
                    const diff = deadline - Date.now();
                    if (diff <= 0) {
                        clearInterval(tick);
                        bar.hidden = true; /* abgelaufen -> Leiste raus */
                        return;
                    }
                    const d = Math.floor(diff / 86400000);
                    const h = Math.floor((diff % 86400000) / 3600000);
                    const m = Math.floor((diff % 3600000) / 60000);
                    const s = Math.floor((diff % 60000) / 1000);
                    valEl.textContent = d > 0
                        ? d + 'T ' + pad(h) + ':' + pad(m) + ':' + pad(s)
                        : pad(h) + ':' + pad(m) + ':' + pad(s);
                }

                render();
                const tick = setInterval(render, 1000);
            }
        }
    })();

    /* ---------- Search Typewriter Placeholder ---------- */
    (function initSearchTypewriter() {
        const input = $('[data-predictive-input]');
        if (!input) return;
        const STATIC = input.placeholder || 'Wonach suchst Du?';
        // Mobil erzwingt styles.css 16px Schriftgroesse im Feld (iOS-Zoom-Schutz),
        // dadurch passen nur ~30 Zeichen hinein — der lange Marketing-Satz lief
        // rechts unters Lupen-Icon und wirkte abgeschnitten.
        const narrow = window.matchMedia('(max-width: 768px)').matches;
        const texts = [
            narrow ? 'Wunschprodukt suchen!' : 'Ohne Umwege: Wunschprodukt einfach suchen!',
            'Neocaridina Garnelen?',
            'Rennschnecken?',
            'Futterpellets?',
            'Garnelen Lollies?',
            'Walnussblätter?',
            'Bodengrund?'
        ];
        const TYPE = 65, ERASE = 30, HOLD = 1800, GAP = 350;
        let idx = 0, ch = 0, mode = 'type', timer = null;

        function paused() {
            return input === document.activeElement || input.value.length > 0;
        }

        function step() {
            if (paused()) { timer = setTimeout(step, 600); return; }
            const t = texts[idx];
            if (mode === 'type') {
                ch++;
                input.placeholder = t.slice(0, ch);
                if (ch >= t.length) { mode = 'hold'; timer = setTimeout(step, HOLD); return; }
                timer = setTimeout(step, TYPE);
            } else if (mode === 'hold') {
                mode = 'erase';
                timer = setTimeout(step, ERASE);
            } else {
                ch--;
                input.placeholder = t.slice(0, ch);
                if (ch <= 0) {
                    mode = 'type';
                    idx = (idx + 1) % texts.length;
                    timer = setTimeout(step, GAP);
                    return;
                }
                timer = setTimeout(step, ERASE);
            }
        }

        input.addEventListener('focus', () => { input.placeholder = STATIC; });
        input.addEventListener('blur', () => {
            if (!input.value) { ch = 0; mode = 'type'; idx = 0; }
        });

        step();
    })();

    /* ---------- Express-Checkout: Wallet-Buttons in eine Zeile ----------
       Shopify rendert Shop Pay, Apple Pay, PayPal und Google Pay selbst in
       <shopify-accelerated-checkout-cart> und kennt zwei Ausgabewege:

       A) Raster (ul.wallet-cart-grid) — sitzt von Haus aus richtig und
          bleibt komplett unangetastet.
       B) Kein Raster (u.a. iOS/Safari): die Buttons liegen roh im Custom
          Element, bekommen per Inline-Style volle Breite und stapeln sich
          zu ueber 170px Hoehe.

       Fuer B wird hier gemessen und verschoben. Safari ignoriert auf diesen
       Custom Elements jedes Fliesslayout (Flex, inline-block, float,
       Tabellenzellen — alles geprueft und wirkungslos), transform dagegen
       ist reines Zeichnen und wird angewandt. offsetTop/offsetLeft liefern
       die Flussposition und bleiben von der eigenen transform unberuehrt,
       dadurch schaukelt sich die Verschiebung nicht auf.

       Zusaetzlich: Auf Apple-Geraeten faellt Google Pay weg (dort ist Apple
       Pay die naheliegende Wahl). Umgekehrt rendert Shopify Apple Pay
       ausserhalb von Apple gar nicht erst — Android bekommt also von selbst
       nur Google Pay. */
    (function initWalletButtons() {
        const SELEKTOR = '.cart-drawer__express, .cart-page__express';
        const LUECKE = 8;   // px zwischen den Buttons
        const HOEHE = 44;   // muss zur Regel in styles.css passen

        let hatApplePay = false;
        try {
            hatApplePay = !!(window.ApplePaySession && ApplePaySession.canMakePayments());
        } catch (err) {
            // canMakePayments wirft in unsicheren Kontexten (z.B. iframe ohne
            // https). Dann bleibt Google Pay sichtbar — das entspricht dem
            // Verhalten ohne diese Anpassung.
        }
        if (hatApplePay) document.documentElement.classList.add('has-apple-pay');

        function sync(box) {
            // Rasterpfad erkennen und in Ruhe lassen.
            const hatRaster = box.querySelector('.wallet-cart-grid') !== null;
            const host = box.querySelector('shopify-accelerated-checkout-cart');
            const ohneRaster = !hatRaster && !!(host && host.querySelector('[slot^="button-"]'));
            box.classList.toggle('express--kein-raster', ohneRaster);

            // Bewusst ohne Geraeteabfrage: der Zweig greift nur, wenn Shopify
            // kein eigenes Raster geliefert hat. Safari auf dem Mac bekommt
            // denselben Shadow-DOM-Pfad wie ein Telefon und braucht die
            // Zeilenrechnung deshalb genauso.
            if (ohneRaster) {
                const gesamt = host.clientWidth;
                // Beim geschlossenen Drawer oder waehrend des Neuaufbaus kann
                // die Breite 0 sein — dann nicht rechnen, der Observer meldet
                // sich wieder, sobald echte Masse anliegen.
                if (gesamt > 0) {
                    const sichtbar = Array.prototype.filter.call(host.children, (el) => {
                        const slot = el.getAttribute && el.getAttribute('slot');
                        return slot && slot.indexOf('button-') === 0
                            && getComputedStyle(el).display !== 'none';
                    });

                    if (sichtbar.length) {
                        const breite = (gesamt - (sichtbar.length - 1) * LUECKE) / sichtbar.length;
                        const ersterTop = sichtbar[0].offsetTop;
                        const ersterLeft = sichtbar[0].offsetLeft;

                        sichtbar.forEach((el, i) => {
                            const zielX = i * (breite + LUECKE);
                            const tx = Math.round(zielX - (el.offsetLeft - ersterLeft)) + 'px';
                            const ty = Math.round(ersterTop - el.offsetTop) + 'px';
                            const w = Math.floor(breite) + 'px';
                            // Nur schreiben, wenn der Wert abweicht: der
                            // Observer hoert auf das style-Attribut und wuerde
                            // sich sonst endlos selbst ausloesen.
                            if (el.style.getPropertyValue('--wallet-w') !== w) {
                                el.style.setProperty('--wallet-w', w);
                            }
                            if (el.style.getPropertyValue('--wallet-tx') !== tx) {
                                el.style.setProperty('--wallet-tx', tx);
                            }
                            if (el.style.getPropertyValue('--wallet-ty') !== ty) {
                                el.style.setProperty('--wallet-ty', ty);
                            }
                        });
                    }
                }
            }

            if (!hatApplePay) return;
            // Google Pay muss komplett aus dem Raster verschwinden: ein blosser
            // display:none am Button laesst seine Kachel als leere Spalte
            // stehen. Bei Shadow-DOM liegt der Button nur projiziert im
            // Raster — der zugehoerige Slot fuehrt zur echten Kachel.
            const gpay = box.querySelector('shopify-google-pay-button, [slot="button-GooglePay"]');
            if (!gpay) return;
            const knoten = gpay.assignedSlot || gpay;
            const kachel = knoten.closest ? knoten.closest('.wallet-cart-button-container') : null;
            const ziel = kachel || gpay;
            if (ziel.style.display !== 'none') ziel.style.display = 'none';
        }

        function bind(box) {
            if (box.__walletGebunden) return;
            box.__walletGebunden = true;
            sync(box);
            // Shopify rendert die Buttons asynchron nach, tauscht sie bei
            // Warenkorb-Updates aus und schreibt beim Wechsel vom Platzhalter
            // auf die echten Buttons das class-Attribut neu — deshalb auch
            // Attribute beobachten, sonst geht die eigene Klasse verloren.
            new MutationObserver(() => sync(box)).observe(box, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'style']
            });
        }

        function bindAlle() {
            $$(SELEKTOR).forEach(bind);
        }

        bindAlle();

        // Drawer und Warenkorbseite werden bei Aenderungen komplett ersetzt
        // (refreshDrawerSection / refreshCartPageSection). Die Beobachter der
        // alten Knoten sterben dabei mit, deshalb wird hier neu gebunden.
        // Der Aufruf ist billig: bind() steigt bei bereits gebundenen Boxen
        // sofort wieder aus.
        let geplant = false;
        new MutationObserver(() => {
            if (geplant) return;
            geplant = true;
            requestAnimationFrame(() => { geplant = false; bindAlle(); });
        }).observe(document.body, { childList: true, subtree: true });

        // Beim Drehen aendert sich die verfuegbare Breite und damit die
        // Aufteilung der Zeile.
        window.addEventListener('resize', () => $$(SELEKTOR).forEach(sync));
        window.addEventListener('orientationchange', () => $$(SELEKTOR).forEach(sync));
    })();

    /* ---------- PLP Filter-Drawer (Mobile) ---------- */
    (function initFilterDrawer() {
        const toggle = $('[data-filter-toggle]');
        const drawer = $('[data-filter-drawer]');
        if (!toggle || !drawer) return;
        let lastFocus = null;
        function open() {
            drawer.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            lockScroll();
            lastFocus = document.activeElement;
            requestAnimationFrame(() => requestAnimationFrame(() => {
                const closeBtn = drawer.querySelector('.sidebar__close, [data-filter-close]');
                if (closeBtn) closeBtn.focus();
            }));
        }
        function close() {
            drawer.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
            unlockScroll();
            if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        }
        toggle.addEventListener('click', (e) => { e.preventDefault(); open(); });
        document.addEventListener('click', (e) => {
            if (e.target.closest('[data-filter-close]')) { e.preventDefault(); close(); }
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
        });
    })();

    /* ---------- Newsletter Submit-Loading ---------- */
    document.addEventListener('submit', (e) => {
        const form = e.target.closest('.js-newsletter-form');
        if (!form) return;
        const btn = form.querySelector('[data-newsletter-submit]');
        if (!btn) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        setTimeout(() => { btn.disabled = false; btn.classList.remove('is-loading'); }, 6000);
    });

    /* ---------- Predictive Search ---------- */
    (function initPredictiveSearch() {
        const form = $('[data-predictive-search]');
        if (!form) return;
        const input = $('[data-predictive-input]', form);
        const box = $('[data-predictive-results]', form);
        if (!input || !box) return;

        let timer = null;
        let lastQuery = '';
        let aborter = null;

        function escapeHtml(str) {
            return String(str).replace(/[&<>"']/g, c => ({
                '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
            }[c]));
        }

        function formatPrice(price) {
            if (price == null || price === '') return '';
            const cents = Math.round(parseFloat(price) * 100);
            return formatMoney(cents);
        }

        function renderResults(data, query) {
            const r = data.resources && data.resources.results ? data.resources.results : {};
            const products = r.products || [];
            if (products.length === 0) {
                box.innerHTML = `<div class="predictive-results__empty">Keine Produkte für „${escapeHtml(query)}".</div>`;
                box.hidden = false;
                return;
            }
            let html = '<div class="predictive-results__group"><div class="predictive-results__title">Produkte</div><ul class="predictive-results__list">';
            products.forEach(p => {
                const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
                const imgHtml = img
                    ? `<img src="${escapeHtml(img)}" alt="" loading="lazy" width="48" height="48">`
                    : `<span class="predictive-results__thumb-placeholder"></span>`;
                html += `<li><a class="predictive-results__item predictive-results__item--product" href="${escapeHtml(p.url)}">
                    <span class="predictive-results__thumb">${imgHtml}</span>
                    <span class="predictive-results__body">
                        <span class="predictive-results__name">${escapeHtml(p.title)}</span>
                        ${p.price != null ? `<span class="predictive-results__price">${formatPrice(p.price)}</span>` : ''}
                    </span>
                </a></li>`;
            });
            html += '</ul></div>';
            html += `<div class="predictive-results__footer"><a href="/search?q=${encodeURIComponent(query)}&type=product">Alle Produkte für „${escapeHtml(query)}" anzeigen</a></div>`;
            box.innerHTML = html;
            box.hidden = false;
        }

        async function runSearch(query) {
            if (aborter) aborter.abort();
            aborter = new AbortController();
            const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`;
            try {
                const res = await fetch(url, { signal: aborter.signal });
                if (!res.ok) return;
                const data = await res.json();
                renderResults(data, query);
            } catch (e) {
                if (e.name === 'AbortError') return;
            }
        }

        input.addEventListener('input', () => {
            const q = input.value.trim();
            if (q.length < 2) {
                box.hidden = true;
                box.innerHTML = '';
                lastQuery = '';
                return;
            }
            if (q === lastQuery) return;
            lastQuery = q;
            clearTimeout(timer);
            timer = setTimeout(() => runSearch(q), 180);
        });

        input.addEventListener('focus', () => {
            if (input.value.trim().length >= 2 && box.innerHTML) {
                box.hidden = false;
            }
        });

        document.addEventListener('click', (e) => {
            if (!form.contains(e.target)) {
                box.hidden = true;
            }
        });

        input.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                box.hidden = true;
                input.blur();
                return;
            }
            if (box.hidden) return;
            const items = Array.from(box.querySelectorAll('.predictive-results__item, .predictive-results__footer a'));
            if (!items.length) return;
            const activeIdx = items.findIndex(el => el.classList.contains('is-focused'));
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const nextIdx = activeIdx < items.length - 1 ? activeIdx + 1 : 0;
                items.forEach(it => it.classList.remove('is-focused'));
                items[nextIdx].classList.add('is-focused');
                items[nextIdx].focus();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prevIdx = activeIdx > 0 ? activeIdx - 1 : items.length - 1;
                items.forEach(it => it.classList.remove('is-focused'));
                items[prevIdx].classList.add('is-focused');
                items[prevIdx].focus();
            } else if (e.key === 'Enter' && activeIdx >= 0) {
                e.preventDefault();
                items[activeIdx].click();
            }
        });
    })();

    /* ---------- PDP Beschreibung Masonry (2-Spalten, shortest-fill) ---------- */
    (function initPdpDescMasonry() {
        const wrap = $('.pdp__desc-tiles');
        if (!wrap) return;
        if (wrap.dataset.masonry === 'done') return;
        if (window.matchMedia('(max-width: 768px)').matches) return;
        const tiles = Array.from(wrap.children);
        if (tiles.length < 2) return;
        const col1 = document.createElement('div');
        const col2 = document.createElement('div');
        col1.className = 'pdp__desc-col';
        col2.className = 'pdp__desc-col';
        wrap.replaceChildren(col1, col2);
        const heights = [0, 0];
        const cols = [col1, col2];
        tiles.forEach(t => {
            const idx = heights[0] <= heights[1] ? 0 : 1;
            cols[idx].appendChild(t);
            heights[idx] += t.offsetHeight + 16;
        });
        wrap.dataset.masonry = 'done';

        const STRETCH_THRESHOLD = 0.65;
        function balanceCols() {
            col1.removeAttribute('data-stretch');
            col2.removeAttribute('data-stretch');
            const h1 = col1.offsetHeight, h2 = col2.offsetHeight;
            if (h1 === h2) return;
            const ratio = Math.min(h1, h2) / Math.max(h1, h2);
            if (ratio >= STRETCH_THRESHOLD) {
                const shortCol = h1 < h2 ? col1 : col2;
                shortCol.dataset.stretch = '1';
            }
        }
        balanceCols();

        wrap.addEventListener('toggle', balanceCols, true);
        let rTimer = null;
        window.addEventListener('resize', () => {
            clearTimeout(rTimer);
            rTimer = setTimeout(balanceCols, 150);
        });
    })();

    /* ---------- PDP Bundle: "Häufig zusammen gekauft" ---------- */
    (function initPdpBundles() {
        const bundles = $$('[data-pdp-bundle]');
        if (!bundles.length) return;
        bundles.forEach(bundle => initOneBundle(bundle));
    })();

    // Klick auf die Bewertungs-Sterne (unter dem Titel) scrollt zum Reviews-Block.
    // Ziel ist der gesamte .pdp__reviews-wrap (inkl. "Bewertungen"-Ueberschrift),
    // nicht nur das Judge.me-Widget — sonst landet man mitten in der Liste.
    // Offset wird live aus der Hoehe des sticky-Headers berechnet (Mobile/Desktop unterschiedlich).
    (function initPdpRatingScroll() {
        const rating = $('.pdp__rating .product-rating');
        const target = $('.pdp__reviews-wrap');
        if (!rating || !target) return;

        function stickyOffset() {
            const header = $('.site-header') || $('#shopify-section-header');
            if (!header) return 0;
            const rect = header.getBoundingClientRect();
            // Nur beruecksichtigen, wenn der Header tatsaechlich oben klebt.
            return rect.top <= 1 ? rect.height : 0;
        }

        function scrollToReviews() {
            const y = window.scrollY + target.getBoundingClientRect().top - stickyOffset() - 12;
            window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
        }

        // Gefuellte Sterne sind ein <div> ohne Link → klickbar/fokussierbar machen.
        if (!rating.matches('a')) {
            rating.setAttribute('role', 'link');
            rating.setAttribute('tabindex', '0');
            rating.style.cursor = 'pointer';
            rating.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    scrollToReviews();
                }
            });
        }

        rating.addEventListener('click', (e) => {
            e.preventDefault();
            scrollToReviews();
        });
    })();

    function initOneBundle(bundle) {
        const items = $$('[data-bundle-item]', bundle);
        const totalEl = $('[data-bundle-total]', bundle);
        const labelEl = $('[data-bundle-label]', bundle);
        const cta = $('[data-bundle-add]', bundle);
        if (!items.length || !totalEl || !cta) return;

        const mainItem = $('[data-bundle-main]', bundle);
        const mainPriceEl = $('[data-bundle-main-price]', bundle);
        const mainBasePrice = mainItem ? parseInt(mainItem.dataset.price, 10) || 0 : 0;
        const qtyInput = $('[data-bundle-qty]', bundle);
        const qtyDec = $('[data-bundle-qty-dec]', bundle);
        const qtyInc = $('[data-bundle-qty-inc]', bundle);

        function getMainQty() {
            if (!qtyInput) return 1;
            let n = parseInt(qtyInput.value, 10) || 1;
            if (n < 1) n = 1;
            if (n > 99) n = 99;
            return n;
        }

        function readTiers() {
            const out = [];
            document.querySelectorAll('[data-pdp-tier][data-min][data-pct]').forEach(t => {
                const m = parseInt(t.dataset.min, 10) || 0;
                const p = parseInt(t.dataset.pct, 10) || 0;
                if (m > 0 && p > 0) out.push({ min: m, pct: p });
            });
            out.sort((a, b) => a.min - b.min);
            return out;
        }
        const tiers = readTiers();

        function getTierPctForQty(qty) {
            let pct = 0;
            for (const t of tiers) {
                if (qty >= t.min && t.pct > pct) pct = t.pct;
            }
            return pct;
        }

        function detectDefaultQty() {
            // Erste Staffel-Schwelle aus dem PDP-Tier-Block lesen (z.B. 10 für Tiere)
            for (const t of tiers) {
                if (t.min > 1) return t.min;
            }
            return 1;
        }

        function update() {
            const mainQty = getMainQty();
            const pct = getTierPctForQty(mainQty);
            const mainGross = mainBasePrice * mainQty;
            // Stueckpreis wie Dealeasy: Rabatt pro Stueck abgerundet, dann x Menge
            const mainNet = pct > 0 ? (mainBasePrice - Math.floor(mainBasePrice * pct / 100)) * mainQty : mainGross;
            let total = 0, count = 0;
            items.forEach(it => {
                const chk = $('[data-bundle-check]', it);
                if (chk && chk.checked) {
                    const isMain = it === mainItem;
                    if (isMain) {
                        total += mainNet;
                    } else {
                        total += parseInt(it.dataset.price, 10) || 0;
                    }
                    count++;
                }
            });
            totalEl.textContent = formatMoney(total);
            if (mainPriceEl) {
                if (pct > 0) {
                    mainPriceEl.innerHTML = `<span class="pdp__bundle-fan-price-strike">${formatMoney(mainGross)}</span> <span class="pdp__bundle-fan-price-net">${formatMoney(mainNet)}</span> <span class="pdp__bundle-fan-price-pct">−${pct}%</span>`;
                } else {
                    mainPriceEl.textContent = formatMoney(mainGross);
                }
            }
            if (labelEl) {
                labelEl.textContent = count > 1
                    ? `Alle ${count} kaufen`
                    : count === 1 ? 'Auswahl kaufen' : 'Nichts ausgewählt';
            }
            cta.disabled = count === 0;
        }

        items.forEach(it => {
            const chk = $('[data-bundle-check]', it);
            if (chk && !chk.disabled) chk.addEventListener('change', update);
        });

        if (qtyInput) {
            const def = detectDefaultQty();
            if (def > 1) qtyInput.value = def;
            qtyInput.addEventListener('input', update);
            qtyInput.addEventListener('change', () => {
                qtyInput.value = getMainQty();
                update();
            });
        }
        if (qtyDec) qtyDec.addEventListener('click', e => {
            e.preventDefault(); e.stopPropagation();
            if (!qtyInput) return;
            qtyInput.value = Math.max(1, getMainQty() - 1);
            update();
        });
        if (qtyInc) qtyInc.addEventListener('click', e => {
            e.preventDefault(); e.stopPropagation();
            if (!qtyInput) return;
            qtyInput.value = Math.min(99, getMainQty() + 1);
            update();
        });

        cta.addEventListener('click', async () => {
            const mainQty = getMainQty();
            const selected = [];
            items.forEach(it => {
                const chk = $('[data-bundle-check]', it);
                if (chk && chk.checked) {
                    const vid = parseInt(it.dataset.variantId, 10);
                    const title = ($('.pdp__bundle-fan-title', it) || $('.pdp__bundle-b-title', it) || {}).textContent || '';
                    const isMain = it === mainItem;
                    if (vid) selected.push({ id: vid, title: title.trim(), qty: isMain ? mainQty : 1 });
                }
            });
            if (!selected.length) return;
            const oldText = cta.textContent;
            cta.disabled = true;
            cta.textContent = 'Wird hinzugefügt …';

            const ok = [];
            const skipped = [];
            for (const it of selected) {
                try {
                    const res = await fetch('/cart/add.js', {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ items: [{ id: it.id, quantity: it.qty || 1 }] })
                    });
                    if (res.ok) {
                        ok.push(it);
                    } else {
                        const errData = await res.json().catch(() => ({}));
                        skipped.push({ ...it, reason: errData.description || errData.message || 'nicht verfügbar' });
                    }
                } catch (err) {
                    skipped.push({ ...it, reason: (err && err.message) || 'Netzwerkfehler' });
                }
            }

            if (ok.length) {
                pulseCart('bump');
                if (typeof refreshDrawerSection === 'function') await refreshDrawerSection();
                if (typeof refreshCartPageSection === 'function') await refreshCartPageSection();
                if (typeof refreshCart === 'function') await refreshCart();
                if (typeof openCart === 'function') openCart();
            }

            if (ok.length && skipped.length) {
                const names = skipped.map(s => s.title).filter(Boolean).join(', ');
                if (typeof showCartError === 'function') {
                    showCartError(`${ok.length} von ${selected.length} hinzugefügt. Übersprungen: ${names || skipped.length + ' Artikel'} (Bestand erreicht).`);
                }
                cta.textContent = `${ok.length} hinzugefügt`;
            } else if (ok.length) {
                cta.textContent = 'Hinzugefügt ✓';
            } else {
                const reason = skipped[0] && skipped[0].reason ? skipped[0].reason : 'Unbekannter Fehler';
                if (typeof showCartError === 'function') showCartError('Nichts hinzugefügt: ' + reason);
                cta.textContent = 'Fehler — erneut versuchen';
            }
            setTimeout(() => { cta.textContent = oldText; cta.disabled = false; update(); }, 2400);
        });

        update();
    }

    /* ---------- Social-Feed-Tab (rechte Lasche) ---------- */
    (function initSocialFeedTab() {
        const tab = $('[data-social-tab]');
        if (!tab) return;

        const STORAGE_KEY = 'shrimp_social_tab_dismissed';
        const AUTO_KEY = 'shrimp_social_tab_autoopened';   // einmal pro Session
        const toggle = $('[data-social-tab-toggle]', tab);
        const closeBtn = $('[data-social-tab-close]', tab);
        const dismissBtn = $('[data-social-tab-dismiss]', tab);
        const feedLink = $('[data-social-tab-feed]', tab);
        const backToTop = $('[data-back-to-top]');
        const threshold = 400;          // nur Fallback, falls kein Back-to-Top-Knopf im Markup
        const AUTO_OPEN_DELAY = 1200;   // ms nach Lasche-Reveal bis Panel aufklappt
        let ticking = false;
        let autoTimer = null;
        let userInteracted = false;     // sobald User selbst tippt: kein Auto-Open mehr

        // Dauerhaft ausgeblendet? Tab gar nicht erst zeigen.
        let dismissed = false;
        try { dismissed = localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}
        if (dismissed) return;

        // Auto-Open nur einmal pro Browser-Session.
        let autoOpened = false;
        try { autoOpened = sessionStorage.getItem(AUTO_KEY) === '1'; } catch (e) {}

        function markAutoOpened() {
            autoOpened = true;
            try { sessionStorage.setItem(AUTO_KEY, '1'); } catch (e) {}
        }
        function cancelAutoOpen() {
            userInteracted = true;
            if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
        }

        // Feed-Sprunglink nur sinnvoll, wenn Ziel-Section auf der Seite existiert.
        const feedTarget = document.getElementById('social-feed');
        if (feedLink && !feedTarget) feedLink.hidden = true;

        tab.hidden = false;
        tab.setAttribute('aria-hidden', 'false');

        function openPanel() {
            tab.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
        }
        function closePanel() {
            tab.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
        }
        function dismiss() {
            closePanel();
            tab.classList.remove('is-revealed');
            tab.hidden = true;
            tab.setAttribute('aria-hidden', 'true');
            try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        }

        // Lasche zeigt sich exakt zusammen mit dem Back-to-Top-Knopf und
        // verschwindet mit ihm wieder; nach kurzer Verzögerung Panel einmalig öffnen.
        function setRevealed(revealed) {
            tab.classList.toggle('is-revealed', revealed);

            if (!revealed) {
                // Lasche weg: offenes Panel schliessen, geplantes Auto-Open verwerfen.
                if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
                closePanel();
                return;
            }

            // Auf Mobilgeraeten kein Auto-Open: das Panel legt sich sonst ueber die
            // Buybox und verdeckt Preis und Kaufen-Button. Die Lasche selbst bleibt.
            const isMobile = window.matchMedia('(max-width: 1024px)').matches;

            if (!isMobile && !autoOpened && !userInteracted && !autoTimer) {
                autoTimer = setTimeout(() => {
                    autoTimer = null;
                    if (userInteracted || autoOpened) return;
                    markAutoOpened();
                    openPanel();
                }, AUTO_OPEN_DELAY);
            }
        }

        if (backToTop) {
            // initBackToTop() laeuft vor diesem Block und meldet jeden Wechsel
            // per Event; den Startzustand direkt vom Knopf uebernehmen.
            document.addEventListener('shrimp:backtotop', (e) => {
                setRevealed(!!(e.detail && e.detail.visible));
            });
            setRevealed(backToTop.classList.contains('is-visible'));
        } else {
            // Fallback ohne Back-to-Top-Knopf: eigene Scroll-Schwelle.
            const updateReveal = () => {
                setRevealed(window.scrollY > threshold);
                ticking = false;
            };
            window.addEventListener('scroll', () => {
                if (!ticking) {
                    window.requestAnimationFrame(updateReveal);
                    ticking = true;
                }
            }, { passive: true });
            updateReveal();
        }

        toggle.addEventListener('click', () => {
            cancelAutoOpen();
            markAutoOpened();
            if (tab.classList.contains('is-open')) closePanel();
            else openPanel();
        });
        if (closeBtn) closeBtn.addEventListener('click', () => { cancelAutoOpen(); markAutoOpened(); closePanel(); });
        if (dismissBtn) dismissBtn.addEventListener('click', dismiss);

        if (feedLink && feedTarget) {
            feedLink.addEventListener('click', (e) => {
                e.preventDefault();
                closePanel();
                feedTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }

        // ESC schließt das Panel.
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && tab.classList.contains('is-open')) closePanel();
        });

        // Klick außerhalb schließt das Panel.
        document.addEventListener('click', (e) => {
            if (tab.classList.contains('is-open') && !tab.contains(e.target)) closePanel();
        });
    })();

    /* ---------- Angebot des Monats — Countdown ---------- */
    (function initAktionCountdown() {
        const box = $('[data-aktion-countdown]');
        if (!box) return;

        const out = {
            days: $('[data-cd="days"]', box),
            hours: $('[data-cd="hours"]', box),
            minutes: $('[data-cd="minutes"]', box),
            seconds: $('[data-cd="seconds"]', box)
        };
        if (!out.days || !out.hours || !out.minutes || !out.seconds) return;

        // Festes Enddatum aus dem Theme-Editor (JJJJ-MM-TT) oder automatisch Monatsende.
        const fixedRaw = (box.dataset.end || '').trim();
        const hasFixed = /^\d{4}-\d{2}-\d{2}$/.test(fixedRaw);

        function targetDate() {
            if (hasFixed) {
                const parts = fixedRaw.split('-').map(Number);
                return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59, 999);
            }
            const now = new Date();
            // Tag 0 des Folgemonats = letzter Tag des laufenden Monats.
            return new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
        }

        let target = targetDate();
        let timer = null;

        const pad = (n) => String(n).padStart(2, '0');

        function render() {
            let diff = target.getTime() - Date.now();

            if (diff <= 0) {
                if (hasFixed) {
                    // Aktion abgelaufen: Countdown ausblenden statt Nullen zeigen.
                    box.hidden = true;
                    if (timer) clearInterval(timer);
                    return;
                }
                // Monatswechsel: neues Ziel berechnen.
                target = targetDate();
                diff = Math.max(0, target.getTime() - Date.now());
            }

            const totalSeconds = Math.floor(diff / 1000);
            out.days.textContent = pad(Math.floor(totalSeconds / 86400));
            out.hours.textContent = pad(Math.floor(totalSeconds / 3600) % 24);
            out.minutes.textContent = pad(Math.floor(totalSeconds / 60) % 60);
            out.seconds.textContent = pad(totalSeconds % 60);
            box.hidden = false;
        }

        render();
        timer = setInterval(render, 1000);
    })();

    /* ---------- Bilder-Karussell (Section "Bilder-Karussell") ----------
       Autoplay laeuft nur, wenn die Section sichtbar ist, der Tab aktiv ist,
       der Nutzer nicht pausiert hat und keine reduzierte Bewegung gewuenscht ist. */
    (function initImageCarousels() {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function setup(root) {
            if (!root || root.dataset.carouselReady === '1') return;

            const track = $('[data-carousel-track]', root);
            const slides = $$('[data-carousel-slide]', root);
            if (!track || slides.length === 0) return;
            root.dataset.carouselReady = '1';

            const dots = $$('[data-carousel-dot]', root);
            const toggleBtn = $('[data-carousel-toggle]', root);
            const isFade = root.classList.contains('img-carousel--fade');
            const autoplayWanted = root.dataset.autoplay === 'true' && slides.length > 1;
            const pauseOnHover = root.dataset.pauseHover === 'true';
            const seconds = parseInt(root.dataset.interval, 10);
            const interval = (isNaN(seconds) ? 6 : Math.max(2, seconds)) * 1000;

            let index = 0;
            let timer = null;
            let userPaused = false;
            let inView = true;
            let observer = null;

            function render() {
                slides.forEach((slide, i) => {
                    const active = i === index;
                    slide.classList.toggle('is-active', active);
                    if (active) {
                        slide.removeAttribute('aria-hidden');
                        slide.removeAttribute('inert');
                    } else {
                        slide.setAttribute('aria-hidden', 'true');
                        slide.setAttribute('inert', '');
                    }
                });
                if (!isFade) track.style.transform = 'translateX(' + (index * -100) + '%)';
                dots.forEach((dot, i) => {
                    const active = i === index;
                    dot.classList.toggle('is-active', active);
                    dot.setAttribute('aria-selected', active ? 'true' : 'false');
                });
            }

            function goTo(target) {
                const count = slides.length;
                index = ((target % count) + count) % count;
                render();
            }
            function next() { goTo(index + 1); }
            function prev() { goTo(index - 1); }

            function canRun() {
                return autoplayWanted && !userPaused && inView && !document.hidden && !reduceMotion.matches;
            }
            function stop() {
                if (timer) { clearInterval(timer); timer = null; }
            }
            function start() {
                stop();
                if (canRun()) timer = setInterval(next, interval);
            }

            /* Nutzer-Navigation: springen und Timer neu starten. */
            function navigate(fn) { fn(); start(); }

            const prevBtn = $('[data-carousel-prev]', root);
            const nextBtn = $('[data-carousel-next]', root);
            if (prevBtn) prevBtn.addEventListener('click', () => navigate(prev));
            if (nextBtn) nextBtn.addEventListener('click', () => navigate(next));

            dots.forEach((dot) => {
                dot.addEventListener('click', () => {
                    const target = parseInt(dot.dataset.index, 10) || 0;
                    navigate(() => goTo(target));
                });
            });

            if (toggleBtn) {
                toggleBtn.addEventListener('click', () => {
                    userPaused = !userPaused;
                    toggleBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
                    toggleBtn.setAttribute('aria-label', userPaused
                        ? 'Automatischen Wechsel starten'
                        : 'Automatischen Wechsel pausieren');
                    if (userPaused) stop(); else start();
                });
            }

            if (pauseOnHover) {
                root.addEventListener('mouseenter', stop);
                root.addEventListener('mouseleave', start);
            }
            root.addEventListener('focusin', stop);
            root.addEventListener('focusout', (e) => {
                if (!root.contains(e.relatedTarget)) start();
            });

            root.addEventListener('keydown', (e) => {
                if (e.key === 'ArrowLeft') { e.preventDefault(); navigate(prev); }
                else if (e.key === 'ArrowRight') { e.preventDefault(); navigate(next); }
            });

            /* Wischen auf Touch-Geraeten */
            let touchX = 0;
            let touchY = 0;
            root.addEventListener('touchstart', (e) => {
                touchX = e.touches[0].clientX;
                touchY = e.touches[0].clientY;
                stop();
            }, { passive: true });
            root.addEventListener('touchend', (e) => {
                const dx = e.changedTouches[0].clientX - touchX;
                const dy = e.changedTouches[0].clientY - touchY;
                if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
                    if (dx < 0) next(); else prev();
                }
                start();
            }, { passive: true });

            document.addEventListener('visibilitychange', start);
            if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', start);

            if ('IntersectionObserver' in window) {
                observer = new IntersectionObserver((entries) => {
                    inView = entries[0].isIntersecting;
                    start();
                }, { threshold: 0.2 });
                observer.observe(root);
            }

            root.__shrimpCarousel = {
                goTo: (i) => navigate(() => goTo(i)),
                start: start,
                stop: stop,
                destroy: () => {
                    stop();
                    if (observer) observer.disconnect();
                }
            };

            render();
            start();
        }

        function setupAll(ctx) {
            $$('[data-carousel]', ctx || document).forEach(setup);
        }

        setupAll(document);

        /* Theme-Editor: Sections werden live neu geladen / selektiert. */
        document.addEventListener('shopify:section:load', (e) => setupAll(e.target));
        document.addEventListener('shopify:section:unload', (e) => {
            $$('[data-carousel]', e.target).forEach((root) => {
                if (root.__shrimpCarousel) root.__shrimpCarousel.destroy();
            });
        });
        document.addEventListener('shopify:section:select', (e) => {
            $$('[data-carousel]', e.target).forEach((root) => {
                if (root.__shrimpCarousel) root.__shrimpCarousel.stop();
            });
        });
        document.addEventListener('shopify:section:deselect', (e) => {
            $$('[data-carousel]', e.target).forEach((root) => {
                if (root.__shrimpCarousel) root.__shrimpCarousel.start();
            });
        });
        document.addEventListener('shopify:block:select', (e) => {
            const slide = e.target.closest('[data-carousel-slide]');
            const root = slide && slide.closest('[data-carousel]');
            if (!root || !root.__shrimpCarousel) return;
            root.__shrimpCarousel.goTo(parseInt(slide.dataset.index, 10) || 0);
            root.__shrimpCarousel.stop();
        });
        document.addEventListener('shopify:block:deselect', (e) => {
            const root = e.target.closest('[data-carousel]');
            if (root && root.__shrimpCarousel) root.__shrimpCarousel.start();
        });
    })();

    /* ============================================================
       VIDEO-BANNER — Quellen erst anhaengen, wenn die Section in
       Scroll-Naehe kommt. Spart mehrere MB beim Seitenaufruf,
       v. a. mobil. Markup liefert die URLs als data-Attribute
       (sections/video-banner.liquid).
       ============================================================ */
    (function initVideoBannerLazy() {
        function attach(video) {
            if (video.dataset.videoLoaded === '1') return;
            /* CSS blendet das Video bei prefers-reduced-motion und bei
               "Video auf Mobilgeraeten ausblenden" aus — dann auch nicht
               laden, display:none verhindert den Download nicht. */
            if (getComputedStyle(video).display === 'none') return;
            video.dataset.videoLoaded = '1';

            [
                [video.dataset.srcHls, video.dataset.typeHls],
                [video.dataset.srcMp4, video.dataset.typeMp4]
            ].forEach(([src, type]) => {
                if (!src) return;
                const source = document.createElement('source');
                source.src = src;
                if (type) source.type = type;
                video.appendChild(source);
            });

            video.load();
            const playing = video.play();
            if (playing && playing.catch) playing.catch(() => {});
        }

        function setup(ctx) {
            $$('video[data-video-lazy]', ctx || document).forEach((video) => {
                if (video.dataset.videoObserved === '1') return;
                video.dataset.videoObserved = '1';

                /* Theme-Editor + alte Browser: sofort laden */
                if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
                    attach(video);
                    return;
                }

                const io = new IntersectionObserver((entries) => {
                    if (!entries.some((entry) => entry.isIntersecting)) return;
                    attach(video);
                    if (video.dataset.videoLoaded === '1') io.disconnect();
                }, { rootMargin: '100% 0px' });
                io.observe(video);
            });
        }

        setup(document);
        document.addEventListener('shopify:section:load', (e) => setup(e.target));
    })();

})();
